import React, {useEffect, useState} from "react";
import { BaseUrl } from "../../../Actions/Base";
import Logo from "../Assets/Logo.png";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import InstructorCards from "./InstructorCards";
import AddClassPopup from "./AddClassPopup";
import axios from "axios";
import SchedulerView from "./TimetableLibrary";
import FinalApiConfirmationPopup from "./FinalSchedulePopup";
import { CreateScheduleA } from "../../../Actions/StudentA";
import { GetLocalStorage } from "../../../Helpers/LocalStorage/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import SuccessPopup from "./SuccessPopup";
import errorMessageImage from "../Assets/errorMessage.png";
import ReuseablePopup from "../../../Components/ReuseablePopups/ReuseablePopup";
import AddClassWeeklySchedulePopup from "./AddClassWeeklySchedulePopup";
import WeeklyScheduleConfirmationPopup from "./WeeklyScheduleConfirmationPopup";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import './DatePicker.css';
import AddClassCustomScheduleLibraryPopup from "./AddClassCustomScheduleLibraryPopup";
import DiscardSchedulePopup from "./DiscardSchedulePopup";
import StudentSelectedHoursPopup from "./ShowStudentSelectedHoursPopup";
import InstituteTrainingFreeHoursPopup from "./ShowInstituteTrainingHoursPopup";

const ScheduleAndInstructorTab = ({ Student, StudentInfo, setActiveTab, CourseInstructors,
     ScheduleTimeTable, CoursePackage, EnrollmentId, timeSlots, allInstructorsScheduledClasses, StudentAllCoursesSchedule }) => {
    const [isOpenInstructorClasses, setIsOpenInstructorClasses] = useState(false);
    const [isOpenStudentSelectedSchedule, setIsOpenStudentSelectedSchedule] = useState(false);
    const [isOpenColorGuidance, setIsOpenColorGuidance] = useState(false);
    const [instructorSelectedType, setInstructorSelectedType] = useState();
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedWeeklyScheduleDate, setSelectedWeeklyScheduleDate] = useState(null);
    const [InstructorState, setInstructorState] = useState([{}, {}, {}])
    const [showAddClassPopup, setShowAddClassPopup] = useState(false);
    const [showWeeklyAddClassPopup, setShowWeeklyAddClassPopup] = useState(false);
    const [showCustomTimeTableLibraryAddPopup, setShowCustomTimeTableLibraryAddPopup] = useState(false);
    const [pendingNewEvent, setPendingNewEvent] = useState(null);


    const [instituteClasses, setInstituteClasses] = useState([]);
    const [selectedInstructorIds, setSelectedInstructorIds] = useState([]); // ✅ empty array by default
    const [studentScheduleEvents, setStudentScheduleEvents] = useState([]);
    const [combinedEvents, setCombinedEvents] = useState(instituteClasses); // initialize with base
    const [addClassEvents, setAddClassEvents] = useState([]); // initialize with base
    const [showScheduleConfirmationPopup, setShowScheduleConfirmationPopup] = useState(false);
    const [finalClassesSchedule, setFinalClassesSchedule] = useState([]); // initialize with base
    const [finalDrivingClassesSchedule, setFinalDrivingClassesSchedule] = useState([]); // initialize with base
    const [finalInClassClassesSchedule, setFinalInClassClassesSchedule] = useState([]); // initialize with base
    const [finalOnlineClassesSchedule, setFinalOnlineClassesSchedule] = useState([]); // initialize with base
    const [selectedDay, setSelectedDay] = useState([]);
    const [startTime, setStartTime] = useState('09:00');
    const [endTime, setEndTime] = useState('10:00');
    const [error, setError] = useState('');
    const [addClassError, setAddClassError] = useState('');
    const [showFinalApiCallPopup, setShowFinalApiCallPopup] = useState(false);
    const [isUpdationFailedPopup, setIsUpdationFailedPopup] = useState(false);
    const [errorMessageText, setErrorMessageText] = useState("Something Went Wrong");
    const [activeType, setActiveType] = useState(null);
    const [openSuccessPopupScreen, setOpenSuccessPopupScreen] = useState(false);
    const [isSeparateSchedule, setIsSeparateSchedule] = useState(false);
    const [isDateSelected, setIsDateSelected] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showWeeklyScheduleCreationPopup, setShowWeeklyScheduleCreationPopup] = useState(false);
    const [showDiscardSchedulePopup, setShowDiscardSchedulePopup] = useState(false);

    const [isOpenThreeDivs, setIsOpenThreeDivs] = useState(false);

    const Dispatch = useDispatch();

    console.log("finalClassesSchedule are:",finalClassesSchedule)
    console.log("allInstructorsScheduledClasses are:",allInstructorsScheduledClasses)
    console.log("StudentAllCoursesSchedule are:",StudentAllCoursesSchedule)

    useEffect(() => {
        console.log("✅ Updated finalClassesSchedule:", finalClassesSchedule);
        console.log("✅ Updated finalOnlineClassesSchedule:", finalOnlineClassesSchedule);
        console.log("✅ Updated finalInClassClassesSchedule:", finalInClassClassesSchedule);
        console.log("✅ Updated finalDrivingClassesSchedule:", finalDrivingClassesSchedule);
        console.log("✅ openSuccessPopupScreen:", openSuccessPopupScreen);
        console.log('selectedDay is:',selectedDay);
      }, [finalClassesSchedule, finalDrivingClassesSchedule, finalOnlineClassesSchedule, finalInClassClassesSchedule, openSuccessPopupScreen, selectedDay]);
      
    const studentImage = `${BaseUrl}/api/images/Student?url=${Student?.StudentImage}`;

    // Function to handle date selection by the user
    const handleDateChange = (newValue) => {
        console.log("newValue is:",newValue)
        setSelectedDate(newValue);
    };  
    
    const SelectInstructor = async (type, instructor) => {
        const InstructorTypes = ['Driving', 'Online', 'InClass'];
        const idx = InstructorTypes.indexOf(type);
        console.log("instructor is:",instructor)
        console.log("idx is:",idx)
        // Create a new array with the updated instructor at the correct index
        const updatedState = InstructorState.map((item, index) =>
          index === idx
            ? {
                id: instructor.Instructor.InstructorId,
                InstructorImage: instructor.Instructor.ProfileImage,
                InstructorName: `${instructor.FirstName} ${instructor.LastName}`,
                text: `${instructor.FirstName} ${instructor.LastName} - ${type}`,
                InstructorType: type,
                LicenseTypeName: instructor.Instructor.InstructorLicenses
                  .map((val) => val.LicenseType.LicenseTypeName)
                  .join(','),
                Email: instructor.Email,
                PhoneNumber: instructor.PhoneNumber,
                InstructorFK: instructor.Instructor.InstructorId,
              }
            : item
        );
        console.log("updatedState is:",updatedState)

        setInstructorState(updatedState);
    };
    
    const showSchedule = async (value, CourseInstructors) => {
        const instructorId = value?.Instructor?.InstructorId;
      
        try {
          const response = await axios.get(`/api/teacher/schedule/${instructorId}`);
          const data = response.data;
          console.log("response.data in the show schedule is:",response.data)

          if (Array.isArray(data) && data.length > 0) {
            const transformedData = data.map((item, index) => ({
              Id: item.EventId || index,
              Subject: `${item.ClassType}`,
              StartTime: new Date(item.startDate),
              EndTime: new Date(item.endDate),
              CategoryColor: '#FF52C5',
              InstructorName: item.InstructorName,
              StudentName: `${item?.CourseEnrollment?.User?.FirstName} ${item?.CourseEnrollment?.User?.LastName}`,
              ClassType: item.ClassType,
              sourceType: 'instructor',
            }));
            console.log("transformedData in the show schedule is:",transformedData)

            setInstituteClasses(transformedData);
            // ✅ Use latest `transformedData` + current student events
                // if (studentScheduleEvents.length > 0) {
                //     setCombinedEvents([...transformedData, ...studentScheduleEvents, ...addClassEvents, ...finalClassesSchedule]);
                // } else {
                //     setCombinedEvents(transformedData);
                // }
            // ✅ Merge only non-empty event arrays
            const allEvents = [
                transformedData,
                studentScheduleEvents,
                addClassEvents,
                finalClassesSchedule
            ];

            const mergedEvents = allEvents
                .filter(arr => Array.isArray(arr) && arr.length > 0)
                .flat();

            setCombinedEvents(mergedEvents);
            } else {
                // ❌ No schedule found for instructor
                console.log("No schedule found for this instructor");
          
                // ⛔ Clear state completely
                setInstituteClasses([]);

                const allEvents = [
                    studentScheduleEvents,
                    addClassEvents,
                    finalClassesSchedule
                ];
    
                const mergedEvents = allEvents
                    .filter(arr => Array.isArray(arr) && arr.length > 0)
                    .flat();

                setCombinedEvents(mergedEvents);
            }
        } catch (error) {
          console.error(error);
        }
      };
      
    const handleCheckboxChange = async (event, instructor) => {
        const instructorId = instructor?.Instructor?.InstructorId;
      
        if (!instructorId) return;
      
        // If the clicked instructor is already selected, unselect it
        if (selectedInstructorIds.includes(instructorId)) {
          setSelectedInstructorIds([]);
        } else {
          setSelectedInstructorIds([instructorId]);
          await showSchedule(instructor, CourseInstructors); // Fetch schedule for newly selected instructor
        }
      };

    // const convertScheduleTimeTable = (scheduleTable) => {
    // const daysMap = {
    //     Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3,
    //     Thursday: 4, Friday: 5, Saturday: 6,
    // };
    
    // const today = new Date();
    // const thisWeekStart = new Date(today.setDate(today.getDate() - today.getDay()));
    // const events = [];
    // let id = 1;
    
    // Object.entries(scheduleTable).forEach(([day, timeSlots]) => {
    //     const dayIndex = daysMap[day];
    //     const baseDate = new Date(thisWeekStart);
    //     baseDate.setDate(thisWeekStart.getDate() + dayIndex);
    
    //     timeSlots.forEach(slot => {
    //     const [startStr, endStr] = slot.split(' - ');
    //     const startDate = new Date(`${baseDate.toDateString()} ${startStr}`);
    //     const endDate = new Date(`${baseDate.toDateString()} ${endStr}`);
    
    //     events.push({
    //         Id: `student-${id++}`,
    //         Subject: 'Free Hour',
    //         StartTime: startDate,
    //         EndTime: endDate,
    //         CategoryColor: '#A1A3EF',
    //         StudentName: 'Student free hour',
    //     });
    //     });
    // });
    
    // console.log("Events in the classes are:",events)
    // return events;
    // };  

    // Pull hours from CoursePackage
    
    const convertScheduleTimeTable = (scheduleTable, startFromDate = new Date(), weeksToGenerate = 4) => {
        const daysMap = {
            Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3,
            Thursday: 4, Friday: 5, Saturday: 6,
        };
    
        const baseStart = new Date(startFromDate);
        baseStart.setHours(0, 0, 0, 0); // normalize time
        const baseWeekStart = new Date(baseStart);
        baseWeekStart.setDate(baseStart.getDate() - baseStart.getDay()); // go to Sunday
    
        const events = [];
        let id = 1;
    
        for (let week = 0; week < weeksToGenerate; week++) {
            const weekStart = new Date(baseWeekStart);
            weekStart.setDate(baseWeekStart.getDate() + week * 7);
    
            Object.entries(scheduleTable).forEach(([day, timeSlots]) => {
                const dayIndex = daysMap[day];
                const targetDate = new Date(weekStart);
                targetDate.setDate(weekStart.getDate() + dayIndex);
    
                timeSlots.forEach(slot => {
                    const [startStr, endStr] = slot.split(' - ');
                    const startDate = new Date(`${targetDate.toDateString()} ${startStr}`);
                    const endDate = new Date(`${targetDate.toDateString()} ${endStr}`);
    
                    // Skip past events
                    if (endDate <= new Date()) return;
    
                    events.push({
                        Id: `student-${id++}`,
                        Subject: 'Free Hour',
                        StartTime: startDate,
                        EndTime: endDate,
                        CategoryColor: '#A1A3EF',
                        StudentName: 'Student free hour',
                        sourceType: 'studentSelectedSchedule',
                    });
                });
            });
        }
    
        console.log("Recurring Free Hour Events:", events);
        return events;
    };
    
    
    const { 
        DrivingHours  = 0, 
        InClassHours  = 0, 
        OnlineHours   = 0 
    } = CoursePackage || {};

    const generateRecurringClasses = ({
        dayTimeCombos,
        instructorType,
        instructorId,
        instructorName,
        totalHours,
        startDate = new Date(),
        existingClassesLength = 0
      }) => {
        const typeColors = {
          Driving: '#0AA630',
          Online: '#FC0000',
          InClass: '#1F7BF4',
        };
      
        const dayNameToIndex = {
          Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3,
          Thursday: 4, Friday: 5, Saturday: 6,
        };
      
        const combosByDay = {};
        for (const combo of dayTimeCombos) {
          const dayIndex = dayNameToIndex[combo.day];
          if (!combosByDay[dayIndex]) combosByDay[dayIndex] = [];
          combosByDay[dayIndex].push({ ...combo, dayIndex });
        }
      
        const events = [];
        let hoursScheduled = 0;
        let currentDate = new Date(startDate);
        currentDate.setHours(0, 0, 0, 0); // normalize
      
        while (hoursScheduled < totalHours) {
          const currentDayIndex = currentDate.getDay();
      
          const combosToday = combosByDay[currentDayIndex] || [];
          for (const combo of combosToday) {
            if (hoursScheduled >= totalHours) break;
      
            const fullStart = new Date(`${currentDate.toDateString()} ${combo.startTime}`);
            const fullEnd = new Date(`${currentDate.toDateString()} ${combo.endTime}`);
      
            if (fullStart < startDate) continue; // avoid past times
      
            const slotDuration = (fullEnd - fullStart) / (1000 * 60 * 60);
            const remainingHours = totalHours - hoursScheduled;
            const classDuration = Math.min(slotDuration, remainingHours);
            const classEnd = new Date(fullStart.getTime() + classDuration * 60 * 60 * 1000);
      
            const event = {
              allDay: false,
              Subject: `${instructorType} Class`,
              StartTime: fullStart,
              EndTime: classEnd,
              startDate: fullStart,
              endDate: classEnd,
              start: fullStart.toISOString(),
              end: classEnd.toISOString(),
              text: '',
              ClassType: instructorType,
              Instructors: instructorId,
              event_id: `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
              ClassNo: existingClassesLength + events.length + 1,
              CategoryColor: typeColors[instructorType] || '#000000',
              InstructorName: instructorName,
              sourceType: 'addClass',
            };
      
            events.push(event);
            hoursScheduled += classDuration;
          }
      
          // Move to the next day
          currentDate.setDate(currentDate.getDate() + 1);
          currentDate.setHours(0, 0, 0, 0);
        }
      
        return events;
      };

    const convertTo24HourTime = (time12h) => {
    const [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':');
    hours = parseInt(hours, 10);
    
    if (modifier === 'PM' && hours !== 12) {
        hours += 12;
    }
    if (modifier === 'AM' && hours === 12) {
        hours = 0;
    }
    
    return `${String(hours).padStart(2, '0')}:${minutes}`;
    };
      
    const getUncoveredTimeRanges = (start, end, daySlots) => {
        const classStart = new Date(`1970-01-01T${convertTo24HourTime(start)}:00`);
        const classEnd = new Date(`1970-01-01T${convertTo24HourTime(end)}:00`);
      
        const slots = daySlots.map(slot => ({
          start: new Date(`1970-01-01T${convertTo24HourTime(slot.StartTime)}:00`),
          end: new Date(`1970-01-01T${convertTo24HourTime(slot.EndTime)}:00`),
        })).sort((a, b) => a.start - b.start);
      
        let current = new Date(classStart);
        let uncovered = [];
      
        while (current < classEnd) {
          const slot = slots.find(slot => slot.start <= current && slot.end > current);
      
          if (slot) {
            current = new Date(Math.min(slot.end, classEnd));
          } else {
            // No slot covers this current time
            const nextSlot = slots.find(slot => slot.start > current);
            const uncoveredEnd = nextSlot ? new Date(Math.min(nextSlot.start, classEnd)) : classEnd;
      
            uncovered.push({
              start: new Date(current),
              end: new Date(uncoveredEnd)
            });
      
            current = uncoveredEnd;
          }
        }
      
        return uncovered;
      };
       

    const handleAddClass = (skipValidation = false) => {
    // if (!skipValidation && (!selectedDay.length || !startTime || !endTime)) {
    //     console.log('selectedDay is:', selectedDay);
    //     setError('Please select at least one day and both start/end time.');
    //     setTimeout(() => setError(''), 10000); // auto-clear after 5 seconds
    //     return;
    // }

    if (!skipValidation) {
        if (!selectedDay.length || !startTime || !endTime) {
          console.log('selectedDay is:', selectedDay);
          setError('Please select at least one day and both start/end time.');
          setTimeout(() => setError(''), 10000); // auto-clear after 10 seconds
          return;
        }
      
        const start = new Date(`1970-01-01T${startTime}`);
        const end = new Date(`1970-01-01T${endTime}`);
        const durationInHours = (end - start) / (1000 * 60 * 60);
      
        if (durationInHours > 8) {
          setError('The class duration exceeds 8 hours. Please reduce the time.');
          setTimeout(() => setError(''), 10000);
          return;
        }
      
        if (durationInHours <= 0) {
          setError('End time must be after start time.');
          setTimeout(() => setError(''), 10000);
          return;
        }
      }      
    
    // ✅ ADD THIS PART RIGHT AFTER THE ABOVE block
    // if (instructorSelectedType !== "Online") {
    //         const violations = [];
    //         const timeRangeToDaysMap = new Map();

    //         for (let day of selectedDay) {
    //             console.log('selectedDay is:', selectedDay);
    //             console.log('startTime is:', startTime);
    //             console.log('endTime is:', endTime);

    //             const daySlots = timeSlots.filter(slot => slot.DayOfWeek === day);
    //             const uncoveredRanges = getUncoveredTimeRanges(startTime, endTime, daySlots);

    //             if (uncoveredRanges.length > 0) {
    //             uncoveredRanges.forEach(({ start, end }) => {
    //                 const timeRange = `${start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    //                 violations.push(`Class on ${day} during ${timeRange} is outside the institute training hours.`);
    //             });
    //             }
    //         }

    //             if (violations.length > 0) {
    //             setError(violations.join('\n'));
    //             setTimeout(() => setError(''), 10000);
    //             return;
    //         }
    // }

    if (instructorSelectedType !== "Online") {
        const timeRangeToDaysMap = new Map();
      
        for (let day of selectedDay) {
          const daySlots = timeSlots.filter(slot => slot.DayOfWeek === day);
          const uncoveredRanges = getUncoveredTimeRanges(startTime, endTime, daySlots);
      
          if (uncoveredRanges.length > 0) {
            uncoveredRanges.forEach(({ start, end }) => {
              const timeRange = `${start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
      
              if (!timeRangeToDaysMap.has(timeRange)) {
                timeRangeToDaysMap.set(timeRange, []);
              }
      
              timeRangeToDaysMap.get(timeRange).push(day);
            });
          }
        }
      
        // Format grouped violations
        const groupedViolations = Array.from(timeRangeToDaysMap.entries()).map(([timeRange, days]) => {
          return `Class on ${days.join(', ')} during ${timeRange} is outside the institute training hours.`;
        });
      
        if (groupedViolations.length > 0) {
          setError(groupedViolations.join('\n'));
          setTimeout(() => setError(''), 10000);
          return;
        }
      }
      

    const totalHoursByType = {
        Driving: DrivingHours,
        Online: OnlineHours,
        InClass: InClassHours,
    };
    
    const totalHours = totalHoursByType[instructorSelectedType] || 0;
    
    const remainingEvents = addClassEvents.filter(
        event => event.ClassType !== instructorSelectedType
    );
    console.log("remainingEvents in function are:",remainingEvents)
    const previousCombos = addClassEvents
        .filter(event => event.ClassType === instructorSelectedType)
        .map(event => {
        const day = new Date(event.startDate).toLocaleDateString('en-US', { weekday: 'long' });
        const startTime = new Date(event.startDate).toTimeString().slice(0, 5);
        const endTime = new Date(event.endDate).toTimeString().slice(0, 5);
        return { day, startTime, endTime };
        });
    console.log("previousCombos in function are:",previousCombos)

    const newCombos = selectedDay.map(day => ({ day, startTime, endTime }));
    
    const comboKey = combo => `${combo.day}-${combo.startTime}-${combo.endTime}`;
    const combinedCombosMap = new Map();
    
    [...previousCombos, ...newCombos].forEach(combo => {
        combinedCombosMap.set(comboKey(combo), combo);
    });
    
    const mergedCombos = Array.from(combinedCombosMap.values());
    
    const typeToIndex = {
        Driving: 0,
        Online: 1,
        InClass: 2,
    };
    
    const idx = typeToIndex[instructorSelectedType] ?? 0;
    const chosenInstructor = InstructorState[idx] || {};
    
    const instructorFullName = chosenInstructor.InstructorName || "";
    const instructorId = chosenInstructor?.InstructorFK || "";
    console.log("instructorId in handle add class is:",instructorId)
    const startDate = selectedDate ? selectedDate.toDate() : new Date();
    
    const newClasses = generateRecurringClasses({
        dayTimeCombos: mergedCombos,
        instructorType: instructorSelectedType,
        instructorId,
        instructorName: instructorFullName,
        totalHours,
        existingClassesLength: remainingEvents.length,
        startDate,
    });
    
    // 🔍 Conflict Check
    const studentScheduleTimes = StudentAllCoursesSchedule.map(item => ({
        start: new Date(item.startDate || item.StartTime),
        end: new Date(item.endDate || item.EndTime)
    }));
    
    const instructorScheduleTimes = allInstructorsScheduledClasses
        .filter(item => item.InstructorId === instructorId)
        .map(item => ({
        start: new Date(item.startDate || item.StartTime),
        end: new Date(item.endDate || item.EndTime)
        }));
    
    const overlaps = (aStart, aEnd, bStart, bEnd) =>
        aStart < bEnd && bStart < aEnd;
    
    for (let newClass of newClasses) {
        const newStart = new Date(newClass.StartTime);
        const newEnd = new Date(newClass.EndTime);
        const formattedDate = newStart.toLocaleDateString('en-US');
        const formattedTime = `${newStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${newEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

        // ❌ 1. Conflict with student's other courses
        const studentConflict = studentScheduleTimes.find(existing =>
        overlaps(newStart, newEnd, existing.start, existing.end)
        );
        if (studentConflict) {
        // const conflictDate = newStart.toLocaleDateString();
        // const conflictTime = `${newStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${newEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
        const overlapStart = new Date(Math.max(newStart, studentConflict.start));
        const overlapEnd = new Date(Math.min(newEnd, studentConflict.end));

        const conflictDate = overlapStart.toLocaleDateString('en-US');
        const conflictTime = `${overlapStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${overlapEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

        setError(`Student already has a class on ${conflictDate} at ${conflictTime} for another course.`);
        setTimeout(() => setError(''), 10000); // auto-clear after 5 seconds
        return;
        }
    
        // ❌ 2. Conflict with instructor's other courses
        const instructorConflict = instructorScheduleTimes.find(existing =>
        overlaps(newStart, newEnd, existing.start, existing.end)
        );
        if (instructorConflict) {
        // const conflictDate = newStart.toLocaleDateString();
        // const conflictTime = `${newStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${newEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
        const overlapStart = new Date(Math.max(newStart, instructorConflict.start));
        const overlapEnd = new Date(Math.min(newEnd, instructorConflict.end));

        const conflictDate = overlapStart.toLocaleDateString('en-US');
        const conflictTime = `${overlapStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${overlapEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

        setError(`Instructor already has a class on ${conflictDate} at ${conflictTime} for another course.`);
        setTimeout(() => setError(''), 10000); // auto-clear after 5 seconds
        return;
        }

        // ❌ 3. Conflict with already added or confirmed classes of this course
        // const newDate = newStart.toDateString(); // exact date

        // const courseConflict = [...addClassEvents, ...finalClassesSchedule].find(existing => {
        //     const existingStart = new Date(existing.startDate || existing.StartTime);
        //     const existingEnd = new Date(existing.endDate || existing.EndTime);
        //     const existingDate = existingStart.toDateString();

        //     // Check exact same date and overlapping time (regardless of class type)
        //     return newDate === existingDate && overlaps(newStart, newEnd, existingStart, existingEnd);
        // });

        // if (courseConflict) {
        //     const overlapStart = new Date(Math.max(newStart, new Date(courseConflict.startDate || courseConflict.StartTime)));
        //     const overlapEnd = new Date(Math.min(newEnd, new Date(courseConflict.endDate || courseConflict.EndTime)));

        //     const conflictDate = overlapStart.toLocaleDateString('en-US');
        //     const conflictTime = `${overlapStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${overlapEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

        //     setError(`❌ A class is already scheduled on ${conflictDate} at ${conflictTime}.`);
        //     setTimeout(() => setError(''), 5000);
        //     return;
        // }
    }
    
    // ✅ No conflicts - set state
    const updatedAddClassEvents = [...remainingEvents, ...newClasses];
    setAddClassEvents(updatedAddClassEvents);
    setCombinedEvents([
        ...studentScheduleEvents,
        ...instituteClasses,
        ...updatedAddClassEvents,
        ...finalClassesSchedule,
    ]);
    
    setSelectedDay([]);
    setError("");
    setShowAddClassPopup(false);
    };      
   
    const handleSeparateScheduleAddClass = () => {
        // 1. Validation
        if (!selectedWeeklyScheduleDate || !startTime || !endTime) {
          console.log("Validation failed", { selectedWeeklyScheduleDate, startTime, endTime });
          setError('Please select a date and both start/end time.');
          setTimeout(() => setError(''), 10000); // auto-clear after 5 seconds
          return;
        }
      
        setError('');

        const start = new Date(`1970-01-01T${startTime}`);
        const end = new Date(`1970-01-01T${endTime}`);
        const durationInHours = (end - start) / (1000 * 60 * 60);
      
        if (durationInHours > 8) {
          setError('The class duration exceeds 8 hours. Please reduce the time.');
          setTimeout(() => setError(''), 10000);
          return;
        }
      
        if (durationInHours <= 0) {
          setError('End time must be after start time.');
          setTimeout(() => setError(''), 10000);
          return;
        }

        // ✅ Check if selected date is in the future
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Ignore time, just compare date

        const selectedDate = new Date(selectedWeeklyScheduleDate);
        selectedDate.setHours(0, 0, 0, 0);

        if (selectedDate <= today) {
        setError('Please select a date in the future to schedule the class.');
        setTimeout(() => setError(''), 10000);
        return;
        }
      
        const classType = instructorSelectedType;
        const totalHoursForType = CoursePackage?.[`${classType}Hours`] || 0;
      
        const getTotalScheduledHours = (scheduleArray) => {
          return scheduleArray.reduce((total, cls) => {
            const start = new Date(cls.StartTime);
            const end = new Date(cls.EndTime);
            return total + (end - start) / (1000 * 60 * 60); // in hours
          }, 0);
        };
      
        let existingScheduledHours = 0;
        if (classType === "Driving") {
          existingScheduledHours = getTotalScheduledHours(finalDrivingClassesSchedule);
        } else if (classType === "Online") {
          existingScheduledHours = getTotalScheduledHours(finalOnlineClassesSchedule);
        } else if (classType === "InClass") {
          existingScheduledHours = getTotalScheduledHours(finalInClassClassesSchedule);
        }
      
        const remainingAllowedHours = totalHoursForType - existingScheduledHours;
        if (remainingAllowedHours <= 0) {
          setError(`Cannot schedule more classes. Total allowed hours (${totalHoursForType}) already used.`);
          return;
        }
      
        const typeToIndex = {
          Driving: 0,
          Online: 1,
          InClass: 2,
        };
      
        const idx = typeToIndex[instructorSelectedType] ?? 0;
        const chosenInstructor = InstructorState[idx] || {};
        console.log("chosenInstructor",chosenInstructor);

        const instructorFullName = chosenInstructor.InstructorName || "";
        console.log("instructorFullName",instructorFullName);

        const instructorId = chosenInstructor?.InstructorFK || "";
      
        const typeColors = {
          Driving: '#0AA630',
          Online: '#FC0000',
          InClass: '#1F7BF4',
        };
      
        // 2. Setup baseDate and time parsing
        const baseDate = new Date(new Date(selectedWeeklyScheduleDate).setHours(0, 0, 0, 0));
        const [startHour, startMin] = startTime.split(':');
        const [endHour, endMin] = endTime.split(':');
      
        const startDate = new Date(baseDate);
        startDate.setHours(+startHour, +startMin, 0, 0);
      
        const endDate = new Date(baseDate);
        endDate.setHours(+endHour, +endMin, 0, 0);

        // ✅ Skip training hour restriction for Online classes
        if (instructorSelectedType !== "Online") {
            const classDay = startDate.toLocaleDateString('en-US', { weekday: 'long' });
            const daySlots = timeSlots.filter(slot => slot.DayOfWeek === classDay);
            const uncovered = getUncoveredTimeRanges(startTime, endTime, daySlots);

            if (uncovered.length > 0) {
            const messages = uncovered.map(({ start, end }) => {
                const timeRange = `${start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
                return `Class on ${classDay} during ${timeRange} is outside the institute training hours.`;
            });

            setError(messages.join('\n'));
            setTimeout(() => setError(''), 10000);
            return;
            }
        }
        
        const proposedDurationInHours = (endDate - startDate) / (1000 * 60 * 60);
      
        if (proposedDurationInHours > remainingAllowedHours) {
          const trimmedEndDate = new Date(startDate.getTime() + remainingAllowedHours * 60 * 60 * 1000);
          endDate.setTime(trimmedEndDate.getTime());
        
          setError(
            `⚠️ The selected time exceeds the remaining allowed hours (${remainingAllowedHours}).\nThe class will be automatically trimmed to ${remainingAllowedHours} hour(s).`
          );
          setTimeout(() => setError(''), 10000); // auto-clear after 5 seconds
          console.log(`Class trimmed to fit remaining ${remainingAllowedHours} hour(s).`);
        }
      
        // 🔍 3. Conflict Check
        const studentScheduleTimes = StudentAllCoursesSchedule.map(item => ({
            start: new Date(item.startDate || item.StartTime),
            end: new Date(item.endDate || item.EndTime),
        }));

        const instructorScheduleTimes = allInstructorsScheduledClasses
            .filter(item => item.InstructorId === instructorId || item.InstructorFK === instructorId)
            .map(item => ({
            start: new Date(item.startDate || item.StartTime),
            end: new Date(item.endDate || item.EndTime),
            }));

        const overlaps = (aStart, aEnd, bStart, bEnd) =>
            aStart < bEnd && bStart < aEnd;

        const formattedDate = startDate.toLocaleDateString('en-US');
        const formattedTime = `${startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${endDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

        const studentConflict = studentScheduleTimes.find(existing =>
            overlaps(startDate, endDate, existing.start, existing.end)
        );
        if (studentConflict) {
            const overlapStart = new Date(Math.max(startDate.getTime(), studentConflict.start.getTime()));
            const overlapEnd = new Date(Math.min(endDate.getTime(), studentConflict.end.getTime()));

            const conflictDate = overlapStart.toLocaleDateString('en-US');
            const conflictTime = `${overlapStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${overlapEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

            setError(`Student already has a class on ${conflictDate} at ${conflictTime} for another course.`);
            setTimeout(() => setError(''), 10000);
            return;
        }

        const instructorConflict = instructorScheduleTimes.find(existing =>
            overlaps(startDate, endDate, existing.start, existing.end)
        );
        if (instructorConflict) {
            const overlapStart = new Date(Math.max(startDate.getTime(), instructorConflict.start.getTime()));
            const overlapEnd = new Date(Math.min(endDate.getTime(), instructorConflict.end.getTime()));

            const conflictDate = overlapStart.toLocaleDateString('en-US');
            const conflictTime = `${overlapStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${overlapEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

            setError(`Instructor already has a class on ${conflictDate} at ${conflictTime} for another course.`);
            setTimeout(() => setError(''), 10000);
            return;
        }

        // ❌ Conflict with other classes of this course (Driving, InClass, Online - all types)
        const courseSchedule = [
            ...addClassEvents,
            ...finalDrivingClassesSchedule,
            ...finalOnlineClassesSchedule,
            ...finalInClassClassesSchedule,
        ];
        
        const courseConflict = courseSchedule.find(existing => {
            const existingStart = new Date(existing.startDate || existing.StartTime);
            const existingEnd = new Date(existing.endDate || existing.EndTime);
            const existingDate = existingStart.toDateString();
            const newDate = startDate.toDateString();
        
            return existingDate === newDate && overlaps(startDate, endDate, existingStart, existingEnd);
        });
        
        if (courseConflict) {
            const overlapStart = new Date(Math.max(startDate.getTime(), new Date(courseConflict.startDate || courseConflict.StartTime).getTime()));
            const overlapEnd = new Date(Math.min(endDate.getTime(), new Date(courseConflict.endDate || courseConflict.EndTime).getTime()));
        
            const conflictDate = overlapStart.toLocaleDateString('en-US');
            const conflictTime = `${overlapStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${overlapEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
        
            setError(`A class for this course already exists on ${conflictDate} at ${conflictTime}.`);
            setTimeout(() => setError(''), 10000);
            return;
        }
  
        // 3. New Class Object
        const newClass = {
          allDay: false,
          Subject: `${instructorSelectedType} Class`,
          StartTime: startDate,
          EndTime: endDate,
          startDate: startDate,
          endDate: endDate,
          start: startDate.toISOString(),
          end: endDate.toISOString(),
          text: '',
          ClassType: instructorSelectedType,
          Instructors: instructorId,
          event_id: `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
          ClassNo: addClassEvents.length + 1,
          CategoryColor: typeColors[instructorSelectedType] || '#000000',
          InstructorName: instructorFullName,
          sourceType: 'addClass',
        };
      
        const updatedAddClassEvents = [...addClassEvents, newClass];
        setAddClassEvents(updatedAddClassEvents);
      
        if (instructorSelectedType === "Driving") {
          setFinalDrivingClassesSchedule(prev => [...prev, newClass]);
        } else if (instructorSelectedType === "Online") {
          setFinalOnlineClassesSchedule(prev => [...prev, newClass]);
        } else if (instructorSelectedType === "InClass") {
          setFinalInClassClassesSchedule(prev => [...prev, newClass]);
        }
      
        setCombinedEvents([
          ...studentScheduleEvents,
          ...instituteClasses,
          ...updatedAddClassEvents,
          ...finalClassesSchedule,
        ]);
      
        // 4. Reset and close modal
        setSelectedWeeklyScheduleDate(null);
        setShowWeeklyAddClassPopup(false);
        setError("");
        // setTimeout(() => {
        //     setShowWeeklyAddClassPopup(false);
        //     setError("");
        //   }, 4000);
      };
      
    // useEffect(() => {
    //     if (selectedDate && !isSeparateSchedule) {
    //          // Auto-assign day from selectedDate
    //         // const autoDay = new Date(selectedDate).toLocaleDateString('en-US', { weekday: 'long' });
    //         // setSelectedDay([autoDay]);
    //         // setSelectedDay(["Monday"]);
    //         console.log("selectedDate is:",selectedDate)
    //         // handleAddClass();
    //         handleAddClass(true); // ✅ Pass true to skip validation
    //     }
    //   }, [selectedDate]);

    useEffect(() => {
        if (selectedDate && !isSeparateSchedule) {
            const now = new Date();
            const selected = new Date(selectedDate);
    
            // Set time of both to 00:00:00 to compare just the date part
            now.setHours(0, 0, 0, 0);
            selected.setHours(0, 0, 0, 0);
    
            // Check if selected date is in the future
            if (selected <= now) {
                setError(" Please select a future date to schedule the class.");
                setTimeout(() => setError(""), 10000);
                return;
            }

            // 🛡️ Guard: Only proceed if instructor type is selected and times/days exist
            // if (!instructorSelectedType || !startTime || !endTime || selectedDay.length === 0) {
            //     return; // Wait until all are set
            // }
    
            if (addClassEvents.length === 0) {
                return;
              }
            // ✅ If valid, proceed
            handleAddClass(true); // skip validation flag passed
        }
    }, [selectedDate]);
    
    useEffect(() => {
    if (openSuccessPopupScreen) {
        console.log("✅ Success popup state is now TRUE — show popup");
    }
    }, [openSuccessPopupScreen]);
      

    const handleScheduleSuccess = () => {
        console.log("✅ Inside handleScheduleSuccess()");
        setOpenSuccessPopupScreen(true);
      };

    // const SubmitSchedule= () =>{
    //     let AssignedInstructors = [];

    //     const uniqueInstructorMap = new Map();

    //     // ✅ Combine all classes into a single array
    //     const AllFinalClassesSchedule = [
    //         ...finalDrivingClassesSchedule,
    //         ...finalInClassClassesSchedule,
    //         ...finalOnlineClassesSchedule,
    //     ];

    //     AllFinalClassesSchedule.forEach(event => {
    //     const instructorId = event?.Instructors;
    //     if (instructorId && !uniqueInstructorMap.has(instructorId)) {
    //         uniqueInstructorMap.set(instructorId, true);
    //         AssignedInstructors.push({
    //         InstructorFK: instructorId,
    //         EnrollmentFK: EnrollmentId,
    //         });
    //     }
    //     });

    //     console.log("AssignedInstructors are:",AssignedInstructors)
    //     const UserEmail = Student?.Email;
    //     const UserFirstName = Student?.FirstName;
    //     const UserLastName = Student?.LastName;

    //     const InsId = GetLocalStorage("UserInfo")?.Institute?.InstituteId;

    //     let EventsFinal;
    //     console.log("finalClassesSchedule in SubmitSchedule are:",finalClassesSchedule)

    //     EventsFinal = AllFinalClassesSchedule.map((value) => {
    //         value.EnrollmentFK = EnrollmentId;
    //         return value;
    //       });

    //     console.log("EventsFinal are:",EventsFinal)

    //     Dispatch(CreateScheduleA({
    //         Events: EventsFinal,
    //         AssignedInstructors: AssignedInstructors,
    //         UserEmail: UserEmail,
    //         InsId: InsId,
    //         UserFirstName: UserFirstName,
    //         UserLastName: UserLastName,
    //         EnrollmentId: EnrollmentId
    //     }, 
    //     () => {
    //         console.log("schedule Registered Successfully 3!");
    //         console.log("openSuccessPopupScreen in dispatch function before",openSuccessPopupScreen);
    //         handleScheduleSuccess(); // 🔁 call wrapper
    //         // setOpenSuccessPopupScreen(!openSuccessPopupScreen)
    //         console.log("openSuccessPopupScreen in dispatch function after",openSuccessPopupScreen)
    //         setTimeout(() => {
    //             console.log("✅ Is popup visible?", openSuccessPopupScreen);
    //           }, 10000);
    //       alert("created")
    //     }, 
    //     (errorMessage) => {
    //         console.error(errorMessage);
    //         setErrorMessageText(errorMessage);
    //         setIsUpdationFailedPopup(true);
    //         alert(errorMessage)
    //     }));

    //     // Dispatch(CreateScheduleA(
    //     //     EventsFinal,            // first param
    //     //     AssignedInstructors,    // second param
    //     //     UserEmail,
    //     //     InsId,
    //     //     UserFirstName,
    //     //     UserLastName,
    //     //     EnrollmentId,
    //     //     () => {
    //     //         console.log("✅ schedule Registered Successfully!");
    //     //         setOpenSuccessPopupScreen(true);
    //     //     },
    //     //     (errorMessage) => {
    //     //         console.error(errorMessage);
    //     //         setErrorMessageText(errorMessage);
    //     //         setIsUpdationFailedPopup(true);
    //     //     }
    //     // ));
        

    //     // Dispatch(CreateScheduleA({
    //     //     Events: EventsFinal,
    //     //     AssignedInstructors: AssignedInstructors,
    //     //     UserEmail: UserEmail,
    //     //     InsId: InsId,
    //     //     UserFirstName: UserFirstName,
    //     //     UserLastName: UserLastName,
    //     //     EnrollmentId: EnrollmentId
    //     // }))
    //     //   .then(() => {
    //     //     setApiSuccessPopup(true); // Show popup on successful update
    //     //   })
    //     //   .catch((error) => {
    //     //     console.error("Error updating settings:", error);
    //     //     setErrorMessageText(error);
    //     //     setIsUpdationFailedPopup(true);
    //     //   });
                    
    //   }

    const SubmitSchedule = async () => {
        setIsSubmitting(true);
        let AssignedInstructors = [];
      
        const uniqueInstructorMap = new Map();
        const AllFinalClassesSchedule = [
          ...finalDrivingClassesSchedule,
          ...finalInClassClassesSchedule,
          ...finalOnlineClassesSchedule,
        ];
      
        AllFinalClassesSchedule.forEach(event => {
          const instructorId = event?.Instructors;
          if (instructorId && !uniqueInstructorMap.has(instructorId)) {
            uniqueInstructorMap.set(instructorId, true);
            AssignedInstructors.push({
              InstructorFK: instructorId,
              EnrollmentFK: EnrollmentId,
            });
          }
        });
      
        const UserEmail = Student?.Email;
        const UserFirstName = Student?.FirstName;
        const UserLastName = Student?.LastName;
        const InsId = GetLocalStorage("UserInfo")?.Institute?.InstituteId;
      
        const EventsFinal = AllFinalClassesSchedule.map((value) => ({
          ...value,
          EnrollmentFK: EnrollmentId,
        }));
      
        try {
          const response = await fetch(`${BaseUrl}/api/schedule/create`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              Events: EventsFinal,
              AssignedInstructors,
              UserEmail,
              InsId,
              UserFirstName,
              UserLastName,
              EnrollmentId,
            }),
          });
      
          const result = await response.json();
      
          if (response.ok) {
            console.log("✅ Schedule created successfully 5!", result);
            setOpenSuccessPopupScreen(true); // <-- this should now work as expected
          } else {
            console.error("🚨 Backend returned error:", result.message || result.error);
            setErrorMessageText(result.message || "Something went wrong.");
            setIsUpdationFailedPopup(true);
          }
        } catch (error) {
          console.error("🚨 Network or unexpected error:", error.message);
          setErrorMessageText("Something went wrong.");
          setIsUpdationFailedPopup(true);
        }
      };
      
      
    const calculateTotalScheduledHours = (schedule) => {
    return schedule.reduce((sum, cls) => {
        const start = new Date(cls.StartTime);
        const end = new Date(cls.EndTime);
        const hours = (end - start) / (1000 * 60 * 60); // milliseconds to hours
        return sum + hours;
    }, 0);
    };
      
    const isEqual = (a, b) => Math.abs(a - b) < 0.01;

    // const isScheduleComplete =
    // isEqual(calculateTotalScheduledHours(finalDrivingClassesSchedule), DrivingHours) &&
    // isEqual(calculateTotalScheduledHours(finalInClassClassesSchedule), InClassHours) &&
    // isEqual(calculateTotalScheduledHours(finalOnlineClassesSchedule), OnlineHours);

    const isScheduleComplete =
        (DrivingHours <= 0 || isEqual(calculateTotalScheduledHours(finalDrivingClassesSchedule), DrivingHours)) &&
        (InClassHours <= 0 || isEqual(calculateTotalScheduledHours(finalInClassClassesSchedule), InClassHours)) &&
        (OnlineHours <= 0 || isEqual(calculateTotalScheduledHours(finalOnlineClassesSchedule), OnlineHours));


    const handleWeeklySchedulePopupConfirmClick = () => {
        setCombinedEvents([
            ...studentScheduleEvents,
            ...instituteClasses,
            ...finalClassesSchedule,
          ]);

        setAddClassEvents([]);
        setIsSeparateSchedule(!isSeparateSchedule);

         // Update based on activeType
        if (activeType === "Driving") {
            setFinalDrivingClassesSchedule([]);
        } else if (activeType === "InClass") {
            setFinalInClassClassesSchedule([]);
        } else if (activeType === "Online") {
            setFinalOnlineClassesSchedule([]);
        } 

        setShowWeeklyScheduleCreationPopup(false);
        };

    const toggleContent = () => {
        setIsOpenThreeDivs((prev) => !prev);
        };

    const handleDiscardScheduleConfirmClick = () => {
        setCombinedEvents([
            ...studentScheduleEvents,
            ...instituteClasses,
            ...finalClassesSchedule,
            ]);

        setAddClassEvents([]);

            // Update based on activeType
        if (activeType === "Driving") {
            setFinalDrivingClassesSchedule([]);
        } else if (activeType === "InClass") {
            setFinalInClassClassesSchedule([]);
        } else if (activeType === "Online") {
            setFinalOnlineClassesSchedule([]);
        } 

        setShowDiscardSchedulePopup(false);
        };

        const [selectedOption, setSelectedOption] = useState('');
        const [showInstituteTrainingFreeHoursPopup, setShowInstituteTrainingFreeHoursPopup] = useState(false);
        const [showStudentFreeHoursPopup, setShowStudentFreeHoursPopup] = useState(false);


        const handleSelect = (option) => {
          setSelectedOption(option);
          
          if (option === 'freeHours') {
            // Open Free Hours popup
            setShowInstituteTrainingFreeHoursPopup(false);
            setShowStudentFreeHoursPopup(true);
            console.log("Free Hours popup opened");
          } else {
            // Open Weekly Schedule popup
            setShowStudentFreeHoursPopup(false);
            setShowInstituteTrainingFreeHoursPopup(true);
            console.log("Weekly Schedule popup opened");
          }
        };
    
    return (
        <div className="w-full flex flex-col justify-center items-center gap-[50px]">
            <div className="flex w-[95%] flex-col gap-[20px] p-[40px] rounded-[8px] bg-[#FFFFFF] shadow-[0px_1px_3px_#00000014]" >
                
                <div className="w-full flex items-center justify-between">  
                    <div className="flex gap-[50px]">
                        <div className="flex items-center gap-[15px]">
                            <img
                                className="w-[55px] h-[55px] rounded-full "
                                src={studentImage}
                                alt=""
                            />
                            <p className="text-[23px]">{Student?.FirstName + " " + Student?.LastName}</p>
                        </div>
                    </div>

                    <div className="4xl:w-[31%] gap-[50px] 4xl:gap-0 flex items-center justify-between" >
                        <div className="flex items-center gap-[10px]">
                            <input
                                type="checkbox"
                                id="myCheckbox"
                                className="w-[20px] h-[20px]"
                                style={{ border: "1px solid #FF52C5" }}
                                checked={isSeparateSchedule}
                                // onChange={(e) => setIsSeparateSchedule(e.target.checked)}
                                // onChange={()=>setShowWeeklyScheduleCreationPopup(true)}
                                onChange={(e) => {
                                    const targetValue = e.target.checked;

                                    if (addClassEvents.length === 0) {
                                    // Directly update without confirmation if no events
                                    setIsSeparateSchedule(targetValue);
                                    } else {
                                    // Show confirmation popup
                                    // setPendingScheduleToggle(targetValue); // track what user wanted
                                    setShowWeeklyScheduleCreationPopup(true);
                                    }
                                }}
                            />
                            <label htmlFor="ScheduleIndividualClass" className="text-[16px] text-[#696974]">
                                    Schedule Individual Class
                            </label>
                        </div>

                        <button
                            onClick={()=> setShowFinalApiCallPopup(true)}
                            type="button"
                            disabled={!isScheduleComplete}  // ✅ This disables the button functionally
                            className={`w-[180px] h-[45px] rounded-[8px] text-[20px] font-poppinssans focus:outline-none focus:ring-4
                                ${isScheduleComplete ? 'bg-[#AEB0FF] text-white cursor-pointer' : 'bg-[#DCDEF6] text-white cursor-not-allowed'}
                                `}
                            // className="bg-[#AEB0FF] w-[180px] h-[45px] rounded-[8px] text-[20px] text-white focus:outline-none focus:ring-4 font-poppinssans"
                        >
                                Create Schedule
                        </button>
                    </div>
                </div>

                <div className="w-full rounded-[13px] p-[10px]"
                    style={{border:"1px solid #AEB0FF"}}>
                        {/* <div className="w-full flex justify-end">
                            <div className="4xl:w-[32%] gap-[50px] 4xl:gap-0 flex items-center justify-between" >
                                <div className="flex items-center gap-[10px]">
                                    <input
                                        type="checkbox"
                                        id="myCheckbox"
                                        className="w-[20px] h-[20px]"
                                        style={{ border: "1px solid #FF52C5" }}
                                        checked={isSeparateSchedule}
                                        // onChange={(e) => setIsSeparateSchedule(e.target.checked)}
                                        // onChange={()=>setShowWeeklyScheduleCreationPopup(true)}
                                        onChange={(e) => {
                                            const targetValue = e.target.checked;

                                            if (addClassEvents.length === 0) {
                                            // Directly update without confirmation if no events
                                            setIsSeparateSchedule(targetValue);
                                            } else {
                                            // Show confirmation popup
                                            // setPendingScheduleToggle(targetValue); // track what user wanted
                                            setShowWeeklyScheduleCreationPopup(true);
                                            }
                                        }}
                                    />
                                    <label htmlFor="myCheckbox" className="text-[16px] text-[#696974]">
                                            Schedule Individual Class
                                    </label>
                                </div>

                                <button
                                    onClick={()=> setShowFinalApiCallPopup(true)}
                                    type="button"
                                    disabled={!isScheduleComplete}  // ✅ This disables the button functionally
                                    className={`w-[180px] h-[45px] rounded-[8px] text-[20px] font-poppinssans focus:outline-none focus:ring-4
                                        ${isScheduleComplete ? 'bg-[#AEB0FF] text-white cursor-pointer' : 'bg-[#DCDEF6] text-white cursor-not-allowed'}
                                        `}
                                    // className="bg-[#AEB0FF] w-[180px] h-[45px] rounded-[8px] text-[20px] text-white focus:outline-none focus:ring-4 font-poppinssans"
                                >
                                        Create Schedule
                                </button>
                            </div>
                        </div> */}

                        <InstructorCards
                            instructors={CourseInstructors}
                            CoursePackage={CoursePackage}
                            setInstructorSelectedType={setInstructorSelectedType}
                            SelectInstructorCallback={SelectInstructor}
                            instructorSelectedType={instructorSelectedType}
                            addClassEvents={addClassEvents}
                            setShowScheduleConfirmationPopup={setShowScheduleConfirmationPopup}
                            showScheduleConfirmationPopup={showScheduleConfirmationPopup}
                            setFinalClassesSchedule={setFinalClassesSchedule}
                            setAddClassEvents={setAddClassEvents}
                            finalClassesSchedule={finalClassesSchedule}
                            activeType={activeType}
                            setActiveType={setActiveType}
                            setFinalDrivingClassesSchedule={setFinalDrivingClassesSchedule}
                            setFinalInClassClassesSchedule={setFinalInClassClassesSchedule}
                            setFinalOnlineClassesSchedule={setFinalOnlineClassesSchedule}
                            isSeparateSchedule={isSeparateSchedule}
                            finalDrivingClassesSchedule={finalDrivingClassesSchedule}
                            finalInClassClassesSchedule={finalInClassClassesSchedule}
                            finalOnlineClassesSchedule={finalOnlineClassesSchedule}
                            setAddClassError={setAddClassError}
                            setShowWeeklyAddClassPopup={setShowWeeklyAddClassPopup}
                            setShowAddClassPopup={setShowAddClassPopup}
                            allInstructorsScheduledClasses={allInstructorsScheduledClasses}
                            setShowDiscardSchedulePopup={setShowDiscardSchedulePopup}
                        />
                </div>


                <div>
                    <button
                        onClick={toggleContent}
                        className={`w-[210px] h-[40px] rounded-[4px] cursor-pointer text-[14px] bg-[#AEB0FF] text-[#FFFFFF] flex justify-center items-center gap-[10px]`}
                    >
                            Information and Legend
                        <span className="text-[30px]">
                            {isOpenThreeDivs ? <KeyboardArrowDownIcon style={{ color: "#FFFFFF", width: "14px" }} /> : <ArrowForwardIosIcon style={{ color: "#FFFFFF", width: "14px"  }} />}
                        </span>
                    </button>
                </div>

                {/* 3 divs */}
                {isOpenThreeDivs && (
                    <div className="w-full flex flex-wrap justify-between items-start rounded-[13px] p-[10px]"
                        style={{border:"1px solid #AEB0FF"}}>
                        {/* Instructor divs */}
                        <div className="w-[32%] flex flex-col gap-[15px]">
                            <div className="flex flex-col gap-[15px] p-[10px] rounded-[7px] shadow-[0px_0px_6px_#00000029]"
                                style={{border:"1px solid #EEEEEE"}}
                                >
                                    <div className="flex justify-between ">
                                        <p className="text-[16px] text-[#696974] font-semibold">See Current Classes</p>
                                    </div>
                                
                                    <div className="w-full flex flex-col gap-[10px] pb-[10px]">
                                        {CourseInstructors.map((instructor, index) => {
                                            const instructorId = instructor?.Instructor?.InstructorId;
                                            const isChecked = Array.isArray(selectedInstructorIds) && selectedInstructorIds.includes(instructorId);

                                            return (
                                                <div key={instructorId || index} className="w-full flex gap-[20px]">
                                                <div className="flex items-center gap-[10px] ml-[10px]">
                                                    <input
                                                    type="checkbox"
                                                    id={`instructor-${instructorId}`}
                                                    className="w-[20px] h-[20px]"
                                                    checked={isChecked}
                                                    onClick={(e) => e.stopPropagation()} // ✅ Prevent parent click
                                                    // onChange={(e) => handleCheckboxChange(e, instructor)}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            handleCheckboxChange(e, instructor)
                                                        } else {
                                                            setInstituteClasses([]);
                                                            setSelectedInstructorIds([]);
                                                            setCombinedEvents([...studentScheduleEvents]); // Reset to original
                                                        }
                                                    }}
                                                    style={{ border: '1px solid #FF52C5' }}
                                                    />
                                                    <label
                                                    htmlFor={`instructor-${instructorId}`}
                                                    className="text-[16px] text-[#696974] cursor-pointer"
                                                    >
                                                    {`${instructor.FirstName} ${instructor.LastName}`}
                                                    </label>
                                                </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                            </div>

                            <div className="flex flex-col gap-[15px] p-[10px] rounded-[7px] shadow-[0px_0px_6px_#00000029]"
                                style={{border:"1px solid #EEEEEE"}}
                                >
                                <div className="flex items-center gap-[15px]">
                                    <div className="flex items-center gap-[5px]">
                                        <input
                                            type="checkbox"
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                const startFrom = new Date();
                                                const transformed = convertScheduleTimeTable(ScheduleTimeTable, startFrom, 20);
                                                setStudentScheduleEvents(transformed);
                                                setCombinedEvents([...instituteClasses, ...transformed, ...addClassEvents, ...finalClassesSchedule]);
                                                } else {
                                                setStudentScheduleEvents([]);
                                                setCombinedEvents([...instituteClasses, ...addClassEvents, ...finalClassesSchedule]); // Reset to original
                                                }
                                            }}
                                            className="w-[20px] h-[20px]"
                                        />
                                        <div className="w-[20px] h-[20px] bg-[#A1A3EF]"></div>
                                    </div> 

                                    <label htmlFor="Learnerfreehours" className="text-[16px] text-[#404040]">
                                        Learner free hours
                                    </label>
                                </div>

                                <div className="flex flex-col justify-center gap-[10px]">
                                    <div className="flex gap-[10px]">
                                            <span className="material-symbols-outlined text-[#A1A3EF]">
                                                radio_button_checked
                                            </span>
                                            <p className="text-[15px] 2xl:text-[16px] text-[#696974]">Instructor Gender Preference</p>
                                            <p className="text-[15px] 2xl:text-[16px] text-[#565656] font-semibold">{StudentInfo?.InstructorPreferredGender ? StudentInfo?.InstructorPreferredGender : "Any Gender"}</p>
                                    </div>

                                    <div className="flex gap-[10px]">
                                            <span className="material-symbols-outlined text-[#A1A3EF]">
                                                radio_button_checked
                                            </span>
                                            <p className="text-[15px] 2xl:text-[16px] text-[#696974]">Instructor Language Preference</p>
                                            <p className="text-[15px] 2xl:text-[16px] text-[#565656] whitespace-normal break-words font-semibold">
                                                {StudentInfo?.InstructorPreferredLanguages
                                                    ? StudentInfo.InstructorPreferredLanguages.replace(/,/g, ',\u200B')
                                                    : "Not Available"}
                                            </p>
                                            {/* <p className="text-[15px] 2xl:text-[16px] text-[#A7A7A7] w-[120px] break-words whitespace-normal 4xl:w-auto font-semibold">{StudentInfo?.InstructorPreferredLanguages ? StudentInfo?.InstructorPreferredLanguages : "Not Available"}</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* student divs */}
                        <div className="flex flex-col gap-[15px] w-[32%] p-[10px] rounded-[7px] shadow-[0px_0px_6px_#00000029]"
                            style={{border:"1px solid #EEEEEE"}} 
                            // onClick={() => setIsOpenStudentSelectedSchedule(!isOpenStudentSelectedSchedule)}
                            >
                                <div className="flex justify-between ">
                                    <p className="text-[16px] text-[#696974] font-semibold">Learner Suggested Schedule</p>
                                    {/* <NavigateNextIcon sx={{ color: '#696974' }} /> */}
                                </div>

                                <div className="w-full flex flex-col gap-[10px] pb-[10px]">
                                    {Object.entries(ScheduleTimeTable)?.map(([day, times]) => (
                                        times.length > 0 && (
                                            <div key={day} className="flex gap-8">
                                            <div className="w-[70px]">
                                                <p className="text-[15px] 2xl:text-[16px]">{day}</p>
                                            </div>
                                            <div className="flex gap-[5px]">
                                                <span className="material-symbols-outlined text-[#A1A3EF]">
                                                radio_button_checked
                                                </span>
                                                <div className="flex flex-col gap-2 text-[15px] 2xl:text-[16px]">
                                                {times.map((slot, index) => (
                                                    <div key={index}>{slot}</div>
                                                ))}
                                                </div>
                                            </div>
                                            </div>
                                        )
                                    ))}

                                </div>
                        </div>

                        {/* indicators divs */}
                        <div className="flex flex-col gap-[15px] w-[32%] p-[10px] rounded-[7px] shadow-[0px_0px_6px_#00000029]"
                            style={{border:"1px solid #EEEEEE"}}
                            >
                                <div className="flex justify-between ">
                                    <p className="text-[16px] text-[#696974] font-semibold">Color Guidance</p>
                                    {/* <NavigateNextIcon sx={{ color: '#696974' }} /> */}
                                </div>

                                <div className="w-full flex flex-col gap-[10px] pb-[10px]">
                                    <div className="flex items-center justify-between ml-[25px]">
                                        <div className="w-[20px] h-[20px] bg-[#FF52C5]"></div>
                                        <label htmlFor="OtherClassesInstructors" className="text-[16px] text-[#404040]">
                                            Other Classes Instructors
                                        </label>
                                    </div>

                                    <div className="flex items-center justify-between ml-[25px]">
                                        {/* <div className="flex items-center gap-[5px]">
                                        <input
                                            type="checkbox"
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                const transformed = convertScheduleTimeTable(ScheduleTimeTable);
                                                setStudentScheduleEvents(transformed);
                                                setCombinedEvents([...instituteClasses, ...transformed, ...addClassEvents, ...finalClassesSchedule]);
                                                } else {
                                                setStudentScheduleEvents([]);
                                                setCombinedEvents([...instituteClasses, ...addClassEvents, ...finalClassesSchedule]); // Reset to original
                                                }
                                            }}
                                            className="w-[20px] h-[20px]"
                                        />
                                        </div> */}

                                        <div className="w-[20px] h-[20px] bg-[#A1A3EF]"></div>
                                        <label htmlFor="freehours" className="text-[16px] text-[#404040]">
                                            Learner free hours
                                        </label>
                                    </div>

                                    <div className="flex items-center justify-between ml-[25px]">
                                        <div className="w-[20px] h-[20px] bg-[#0AA630]"></div>
                                        <label htmlFor="In-Vehicle" className="text-[16px] text-[#404040]">
                                            In-Vehicle Hours
                                        </label>
                                    </div>

                                    <div className="flex items-center justify-between ml-[25px]">
                                        <div className="w-[20px] h-[20px] bg-[#5298F5]"></div>
                                        <label htmlFor="In-Class" className="text-[16px] text-[#404040]">
                                            In-Class hours
                                        </label>
                                    </div>

                                    <div className="flex items-center justify-between ml-[25px]">
                                        <div className="w-[20px] h-[20px] bg-[#FC0000]"></div>
                                        <label htmlFor="Online/Other" className="text-[16px] text-[#404040]">
                                            Online/Other Hours
                                        </label>
                                    </div>
                                    
                                </div>
                        </div>
                    </div>
                )}

                {/* calendar */}
                <div className="w-full flex items-center justify-between">
                    <div className='flex gap-[20px] items-center'>
                        <p className="text-[16px] font-semibold text-[#696974]">Schedule Start Date</p>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <div className="custom-datepicker">
                                <DatePicker
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        size="small" // This reduces vertical padding
                                        InputProps={{
                                            ...params.InputProps,
                                            style: {
                                            height: '20px',         // Controls overall height
                                            padding: '0 8px',       // Optional tighter padding
                                            fontSize: '14px',       // Optional smaller text
                                            },
                                        }}
                                        InputLabelProps={{
                                            ...params.InputLabelProps,
                                            style: {
                                            fontSize: '14px',
                                            },
                                        }}
                                    />}
                                />
                            </div>
                        </LocalizationProvider>
                    </div>

                    <div className="4xl:w-[32%] gap-[50px] 4xl:gap-0 flex items-center justify-between">
                       

                        <div className="flex flex-col gap-[5px]">
                            {/* <button
                                // onClick={()=> setShowAddClassPopup(true)}
                                onClick={() => {
                                    if (!activeType) {
                                        setAddClassError("Please select class type first.");
                                        setTimeout(() => setAddClassError(''), 5000);
                                    } else if (isSeparateSchedule) {
                                        setAddClassError("")
                                        setShowWeeklyAddClassPopup(true);
                                    } else {
                                        setAddClassError("")
                                        setShowAddClassPopup(true);
                                    }
                                }}
                                type="button"
                                className="bg-[#AEB0FF] w-[95px] h-[40px] rounded-[4px] text-[16px] text-white focus:outline-none focus:ring-4"
                            >
                                    Add Class
                            </button> */}

                            {/* {addClassError && <p className="text-[#FF0000]">{addClassError}</p>} */}
                            {addClassError && (
                                <div className="fixed flex items-center gap-[10px] bottom-5 right-5 z-[999] px-6 py-2 rounded-lg bg-[linear-gradient(90deg,_#FFFFFF_0%,_#D7D9FF_100%)] bg-no-repeat text-[#F93D5C] text-[16px] shadow-[0_0_8px_#00000029] rounded-[9px] animate-fade-in-out"
                                style={{border:"1px solid #DCDCDC"}}>
                                    <img className='h-6 relative -top-[2px] md:top-0 md:h-auto' 
                                        src={require('../Assets/ErrorIcon.svg').default} 
                                        alt=""
                                    /> 
                                    {addClassError}
                                </div>
                            )}
                        </div>


                        {/* { showAddClassPopup && ( 
                            <div className="fixed inset-0 z-[99] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
                                <div className="relative z-10">
                                    <AddClassPopup
                                        showAddClassPopup={showAddClassPopup}
                                        setShowOwnTimeFields={setShowAddClassPopup}
                                        instructorTypeExtracted={instructorSelectedType}
                                        InstructorState={InstructorState}
                                        setCombinedEvents={setCombinedEvents}
                                        instituteClasses={instituteClasses}
                                        studentScheduleEvents={studentScheduleEvents}
                                        setAddClassEvents={setAddClassEvents}
                                        addClassEvents={addClassEvents}
                                        CoursePackage={CoursePackage}
                                        timeSlots={timeSlots}
                                        selectedDate={selectedDate}
                                        selectedDay={selectedDay}
                                        setSelectedDay={setSelectedDay}
                                        startTime={startTime}
                                        setStartTime={setStartTime}
                                        endTime={endTime}
                                        setEndTime={setEndTime} 
                                        handleAddClass={handleAddClass}
                                        error={error}
                                        setError={setError}
                                        isSeparateSchedule={isSeparateSchedule}
                                        handleSeparateScheduleAddClass={handleSeparateScheduleAddClass}
                                        selectedOption={selectedOption}
                                        setSelectedOption={setSelectedOption}
                                        handleSelect={handleSelect}
                                    /> 
                                </div>

                                    {showStudentFreeHoursPopup && (
                                        <div className="relative z-20 ml-4">
                                            <StudentSelectedHoursPopup
                                                setShowStudentFreeHoursPopup={setShowStudentFreeHoursPopup}
                                                ScheduleTimeTable={ScheduleTimeTable}
                                            />
                                        </div>
                                    )}

                                    {showInstituteTrainingFreeHoursPopup && (
                                        <div className="relative z-20 ml-4">
                                            <InstituteTrainingFreeHoursPopup
                                                setShowInstituteTrainingFreeHoursPopup={setShowInstituteTrainingFreeHoursPopup}
                                                timeSlots={timeSlots}
                                            />
                                        </div>
                                    )}
                            </div>
                        )} */}


                        {showAddClassPopup && (
                            <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
                                {/* Flex container to hold popups side-by-side */}
                                <div className="relative flex items-start">
                                {/* Add Class Popup */}
                                <div className="relative z-10">
                                <AddClassPopup
                                        showAddClassPopup={showAddClassPopup}
                                        setShowOwnTimeFields={setShowAddClassPopup}
                                        instructorTypeExtracted={instructorSelectedType}
                                        InstructorState={InstructorState}
                                        setCombinedEvents={setCombinedEvents}
                                        instituteClasses={instituteClasses}
                                        studentScheduleEvents={studentScheduleEvents}
                                        setAddClassEvents={setAddClassEvents}
                                        addClassEvents={addClassEvents}
                                        CoursePackage={CoursePackage}
                                        timeSlots={timeSlots}
                                        selectedDate={selectedDate}
                                        selectedDay={selectedDay}
                                        setSelectedDay={setSelectedDay}
                                        startTime={startTime}
                                        setStartTime={setStartTime}
                                        endTime={endTime}
                                        setEndTime={setEndTime} 
                                        handleAddClass={handleAddClass}
                                        error={error}
                                        setError={setError}
                                        isSeparateSchedule={isSeparateSchedule}
                                        handleSeparateScheduleAddClass={handleSeparateScheduleAddClass}
                                        selectedOption={selectedOption}
                                        setSelectedOption={setSelectedOption}
                                        handleSelect={handleSelect}
                                        setShowStudentFreeHoursPopup={setShowStudentFreeHoursPopup}
                                        setShowInstituteTrainingFreeHoursPopup={setShowInstituteTrainingFreeHoursPopup}
                                    /> 
                                </div>

                                {/* Student Free Hours Popup */}
                                {showStudentFreeHoursPopup && (
                                    <div className="absolute left-full top-0 ml-4 z-20">
                                    <StudentSelectedHoursPopup
                                        setShowStudentFreeHoursPopup={setShowStudentFreeHoursPopup}
                                        ScheduleTimeTable={ScheduleTimeTable}
                                    />
                                    </div>
                                )}

                                {/* Institute Training Free Hours Popup */}
                                {showInstituteTrainingFreeHoursPopup && (
                                    <div className="absolute left-full top-0 ml-4 z-20">
                                    <InstituteTrainingFreeHoursPopup
                                        setShowInstituteTrainingFreeHoursPopup={setShowInstituteTrainingFreeHoursPopup}
                                        timeSlots={timeSlots}
                                    />
                                    </div>
                                )}
                                </div>
                            </div>
                        )}

                    </div>
                </div>

                {/* {error && <p className="text-[#FF0000]">{error}</p>} */}
                {error && (
                    <div className="fixed flex items-center gap-[10px] bottom-5 right-5 z-[999] px-6 py-2 rounded-lg 
                    bg-[linear-gradient(90deg,_#FFFFFF_0%,_#DFE0FF_28%,_#D7D9FF_100%)] bg-no-repeat text-[#F93D5C] text-[16px] shadow-[0_0_8px_#00000029] rounded-[4px] animate-fade-in-out
                    max-w-[450px] 2.5xl:max-w-[550px] whitespace-pre-wrap break-words"
                    style={{border:"1px solid #DCDCDC"}}>
                        <img className='h-6 relative -top-[2px] md:top-0 md:h-auto' 
                            src={require('../Assets/ErrorIcon.svg').default} 
                            alt=""
                        /> 
                        {error}
                    </div>
                )}


                <SchedulerView
                    instituteClasses={combinedEvents}
                    activeType={activeType}
                    setCombinedEvents={setCombinedEvents}
                    setFinalDrivingClassesSchedule={setFinalDrivingClassesSchedule}
                    setFinalInClassClassesSchedule={setFinalInClassClassesSchedule}
                    setFinalOnlineClassesSchedule={setFinalOnlineClassesSchedule}
                    finalDrivingClassesSchedule={finalDrivingClassesSchedule}
                    finalInClassClassesSchedule={finalInClassClassesSchedule}
                    finalOnlineClassesSchedule={finalOnlineClassesSchedule}
                    setAddClassEvents={setAddClassEvents}
                    addClassEvents={addClassEvents}
                    setFinalClassesSchedule={setFinalClassesSchedule}
                    StudentAllCoursesSchedule={StudentAllCoursesSchedule}
                    allInstructorsScheduledClasses={allInstructorsScheduledClasses}
                    setError={setError}
                    CoursePackage={CoursePackage}
                    setShowWeeklyAddClassPopup={setShowWeeklyAddClassPopup}
                    setShowCustomTimeTableLibraryAddPopup={setShowCustomTimeTableLibraryAddPopup}
                    setPendingNewEvent={setPendingNewEvent}
                    finalClassesSchedule={finalClassesSchedule}
                />

                {showWeeklyScheduleCreationPopup && (
                    <WeeklyScheduleConfirmationPopup
                        setShowWeeklyScheduleCreationPopup={setShowWeeklyScheduleCreationPopup}
                        handleWeeklySchedulePopupConfirmClick={handleWeeklySchedulePopupConfirmClick}
                    />
                )}

                {showDiscardSchedulePopup && (
                    <DiscardSchedulePopup
                        setShowDiscardSchedulePopup={setShowDiscardSchedulePopup}
                        handleDiscardScheduleConfirmClick={handleDiscardScheduleConfirmClick}
                    />
                )}

                {showFinalApiCallPopup && (
                    <FinalApiConfirmationPopup
                        setShowFinalApiCallPopup={setShowFinalApiCallPopup}
                        SubmitSchedule={SubmitSchedule}
                        isSubmitting={isSubmitting}
                    />
                )}

                {/* {showWeeklyAddClassPopup && (
                    <AddClassWeeklySchedulePopup
                            showAddClassPopup={showWeeklyAddClassPopup}
                            setShowOwnTimeFields={setShowWeeklyAddClassPopup}
                            instructorTypeExtracted={instructorSelectedType}
                            InstructorState={InstructorState}
                            setCombinedEvents={setCombinedEvents}
                            instituteClasses={instituteClasses}
                            studentScheduleEvents={studentScheduleEvents}
                            setAddClassEvents={setAddClassEvents}
                            addClassEvents={addClassEvents}
                            CoursePackage={CoursePackage}
                            timeSlots={timeSlots}
                            selectedDate={selectedDate}
                            selectedDay={selectedDay}
                            setSelectedDay={setSelectedDay}
                            startTime={startTime}
                            setStartTime={setStartTime}
                            endTime={endTime}
                            setEndTime={setEndTime} 
                            handleAddClass={handleAddClass}
                            error={error}
                            setError={setError}
                            isSeparateSchedule={isSeparateSchedule}
                            handleSeparateScheduleAddClass={handleSeparateScheduleAddClass}
                            setSelectedWeeklyScheduleDate={setSelectedWeeklyScheduleDate}
                            selectedWeeklyScheduleDate={selectedWeeklyScheduleDate}
                    />
                )} */}

                {showWeeklyAddClassPopup && (
                            <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
                                {/* Flex container to hold popups side-by-side */}
                                <div className="relative flex items-start">
                                {/* Add Class Popup */}
                                <div className="relative z-10">
                                <AddClassWeeklySchedulePopup
                                        showAddClassPopup={showWeeklyAddClassPopup}
                                        setShowOwnTimeFields={setShowWeeklyAddClassPopup}
                                        instructorTypeExtracted={instructorSelectedType}
                                        InstructorState={InstructorState}
                                        setCombinedEvents={setCombinedEvents}
                                        instituteClasses={instituteClasses}
                                        studentScheduleEvents={studentScheduleEvents}
                                        setAddClassEvents={setAddClassEvents}
                                        addClassEvents={addClassEvents}
                                        CoursePackage={CoursePackage}
                                        timeSlots={timeSlots}
                                        selectedDate={selectedDate}
                                        selectedDay={selectedDay}
                                        setSelectedDay={setSelectedDay}
                                        startTime={startTime}
                                        setStartTime={setStartTime}
                                        endTime={endTime}
                                        setEndTime={setEndTime} 
                                        handleAddClass={handleAddClass}
                                        error={error}
                                        setError={setError}
                                        isSeparateSchedule={isSeparateSchedule}
                                        handleSeparateScheduleAddClass={handleSeparateScheduleAddClass}
                                        setSelectedWeeklyScheduleDate={setSelectedWeeklyScheduleDate}
                                        selectedWeeklyScheduleDate={selectedWeeklyScheduleDate}
                                        handleSelect={handleSelect}
                                        setShowStudentFreeHoursPopup={setShowStudentFreeHoursPopup}
                                        setShowInstituteTrainingFreeHoursPopup={setShowInstituteTrainingFreeHoursPopup}
                                    /> 
                                </div>

                                {/* Student Free Hours Popup */}
                                {showStudentFreeHoursPopup && (
                                    <div className="absolute left-full top-0 ml-4 z-20">
                                    <StudentSelectedHoursPopup
                                        setShowStudentFreeHoursPopup={setShowStudentFreeHoursPopup}
                                        ScheduleTimeTable={ScheduleTimeTable}
                                    />
                                    </div>
                                )}

                                {/* Institute Training Free Hours Popup */}
                                {showInstituteTrainingFreeHoursPopup && (
                                    <div className="absolute left-full top-0 ml-4 z-20">
                                    <InstituteTrainingFreeHoursPopup
                                        setShowInstituteTrainingFreeHoursPopup={setShowInstituteTrainingFreeHoursPopup}
                                        timeSlots={timeSlots}
                                    />
                                    </div>
                                )}
                                </div>
                            </div>
                        )}

                {/* {showCustomTimeTableLibraryAddPopup && (
                    <AddClassCustomScheduleLibraryPopup
                            setCombinedEvents={setCombinedEvents}
                            instituteClasses={instituteClasses}
                            studentScheduleEvents={studentScheduleEvents}
                            setAddClassEvents={setAddClassEvents}
                            addClassEvents={addClassEvents}
                            CoursePackage={CoursePackage}
                            startTime={startTime}
                            setStartTime={setStartTime}
                            endTime={endTime}
                            setEndTime={setEndTime} 
                            setError={setError}
                            setSelectedWeeklyScheduleDate={setSelectedWeeklyScheduleDate}
                            selectedWeeklyScheduleDate={selectedWeeklyScheduleDate}
                            setShowCustomTimeTableLibraryAddPopup={setShowCustomTimeTableLibraryAddPopup}
                            CourseInstructors={CourseInstructors}
                            setFinalDrivingClassesSchedule={setFinalDrivingClassesSchedule}
                            setFinalInClassClassesSchedule={setFinalInClassClassesSchedule}
                            setFinalOnlineClassesSchedule={setFinalOnlineClassesSchedule}
                            finalDrivingClassesSchedule={finalDrivingClassesSchedule}
                            finalInClassClassesSchedule={finalInClassClassesSchedule}
                            finalOnlineClassesSchedule={finalOnlineClassesSchedule}
                            StudentAllCoursesSchedule={StudentAllCoursesSchedule}
                            allInstructorsScheduledClasses={allInstructorsScheduledClasses}
                            finalClassesSchedule={finalClassesSchedule}
                            pendingNewEvent={pendingNewEvent}
                            getUncoveredTimeRanges={getUncoveredTimeRanges}
                            timeSlots={timeSlots}
                            setFinalClassesSchedule={setFinalClassesSchedule}
                    />
                )} */}

                {showCustomTimeTableLibraryAddPopup && (
                            <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
                                {/* Flex container to hold popups side-by-side */}
                                <div className="relative flex items-start">
                                {/* Add Class Popup */}
                                <div className="relative z-10">
                                <AddClassCustomScheduleLibraryPopup
                                        setCombinedEvents={setCombinedEvents}
                                        instituteClasses={instituteClasses}
                                        studentScheduleEvents={studentScheduleEvents}
                                        setAddClassEvents={setAddClassEvents}
                                        addClassEvents={addClassEvents}
                                        CoursePackage={CoursePackage}
                                        startTime={startTime}
                                        setStartTime={setStartTime}
                                        endTime={endTime}
                                        setEndTime={setEndTime} 
                                        setError={setError}
                                        setSelectedWeeklyScheduleDate={setSelectedWeeklyScheduleDate}
                                        selectedWeeklyScheduleDate={selectedWeeklyScheduleDate}
                                        setShowCustomTimeTableLibraryAddPopup={setShowCustomTimeTableLibraryAddPopup}
                                        CourseInstructors={CourseInstructors}
                                        setFinalDrivingClassesSchedule={setFinalDrivingClassesSchedule}
                                        setFinalInClassClassesSchedule={setFinalInClassClassesSchedule}
                                        setFinalOnlineClassesSchedule={setFinalOnlineClassesSchedule}
                                        finalDrivingClassesSchedule={finalDrivingClassesSchedule}
                                        finalInClassClassesSchedule={finalInClassClassesSchedule}
                                        finalOnlineClassesSchedule={finalOnlineClassesSchedule}
                                        StudentAllCoursesSchedule={StudentAllCoursesSchedule}
                                        allInstructorsScheduledClasses={allInstructorsScheduledClasses}
                                        finalClassesSchedule={finalClassesSchedule}
                                        pendingNewEvent={pendingNewEvent}
                                        getUncoveredTimeRanges={getUncoveredTimeRanges}
                                        timeSlots={timeSlots}
                                        setFinalClassesSchedule={setFinalClassesSchedule}
                                        handleSelect={handleSelect}
                                        setShowStudentFreeHoursPopup={setShowStudentFreeHoursPopup}
                                        setShowInstituteTrainingFreeHoursPopup={setShowInstituteTrainingFreeHoursPopup}
                                    /> 
                                </div>

                                {/* Student Free Hours Popup */}
                                {showStudentFreeHoursPopup && (
                                    <div className="absolute left-full top-0 ml-4 z-20">
                                    <StudentSelectedHoursPopup
                                        setShowStudentFreeHoursPopup={setShowStudentFreeHoursPopup}
                                        ScheduleTimeTable={ScheduleTimeTable}
                                    />
                                    </div>
                                )}

                                {/* Institute Training Free Hours Popup */}
                                {showInstituteTrainingFreeHoursPopup && (
                                    <div className="absolute left-full top-0 ml-4 z-20">
                                    <InstituteTrainingFreeHoursPopup
                                        setShowInstituteTrainingFreeHoursPopup={setShowInstituteTrainingFreeHoursPopup}
                                        timeSlots={timeSlots}
                                    />
                                    </div>
                                )}
                                </div>
                            </div>
                        )}

                {openSuccessPopupScreen && (
                    <SuccessPopup
                        setSuccess={setOpenSuccessPopupScreen}
                    />
                )}

                {isUpdationFailedPopup && (
                    <ReuseablePopup
                    setShowPopup={setIsUpdationFailedPopup}
                    heading="Oops!"
                    text={errorMessageText}
                    btnText="Back"
                    onClick={() => setIsUpdationFailedPopup(false)} // <-- Add this line
                    imageSrc={errorMessageImage} // ✅ Dynamic image source
                    />
                )}

            </div>
        </div>
    );
};

export default ScheduleAndInstructorTab;



                {/* <div className="flex flex-wrap justify-center 4xl:justify-between items-center gap-[30px] w-full">
                    <div className="flex justify-between w-[400px] 4xl:w-[30%] h-[105px] bg-[#FAFAFB] pl-[15px]">
                        <div className="flex gap-[10px] items-center">
                            <img src={Logo} alt="Logo" />
                            <p className="text-[16px] font-semibold text-[#696974]">Ali Abdaal</p>
                            <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#0AA630]"><ArrowBackIcon sx={{ color: 'white' }} /></div>
                            <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#0AA630]"><ArrowForwardIcon sx={{ color: 'white' }} /></div>
                        </div>

                        <div className="bg-[#EBF8EE] bg-no-repeat p-[10px] flex flex-col gap-[10px] justify-center items-center"
                            style={{border: "1px solid #0AA630"}}>
                                <p className="text-[14px] text-[#696974] font-poppinssans text-center w-[80px]">In-Vehicle Classes</p>
                                <p className="text-[16px] text-[#696974] font-semibold">10 Hrs</p>
                        </div>
                    </div>

                    <div className="flex justify-between w-[400px] 4xl:w-[30%] h-[105px] bg-[#FAFAFB] pl-[15px]">
                        <div className="flex gap-[10px] items-center">
                            <img src={Logo} alt="Logo" />
                            <p className="text-[16px] font-semibold text-[#696974]">Ali Abdaal</p>
                            <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#1F7BF4]"><ArrowBackIcon sx={{ color: 'white' }} /></div>
                            <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#1F7BF4]"><ArrowForwardIcon sx={{ color: 'white' }} /></div>
                        </div>

                        <div className="bg-[#FAFAFB] bg-no-repeat p-[10px] flex flex-col gap-[10px] justify-center items-center"
                            style={{border: "1px solid #1F7BF4"}}>
                                <p className="text-[14px] text-[#696974] font-poppinssans text-center w-[80px]">In-Vehicle Classes</p>
                                <p className="text-[16px] text-[#696974] font-semibold">10 Hrs</p>
                        </div>
                    </div>

                    <div className="flex justify-between w-[400px] 4xl:w-[30%] h-[105px] bg-[#FAFAFB] pl-[15px]">
                        <div className="flex gap-[10px] items-center">
                            <img src={Logo} alt="Logo" />
                            <p className="text-[16px] font-semibold text-[#696974]">Ali Abdaal</p>
                            <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#FC0000]"><ArrowBackIcon sx={{ color: 'white' }} /></div>
                            <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#FC0000]"><ArrowForwardIcon sx={{ color: 'white' }} /></div>
                        </div>

                        <div className="bg-[#FFEBEB] bg-no-repeat p-[10px] flex flex-col gap-[10px] justify-center items-center"
                            style={{border: "1px solid #FC0000"}}>
                                <p className="text-[14px] text-[#696974] font-poppinssans text-center w-[80px]">In-Vehicle Classes</p>
                                <p className="text-[16px] text-[#696974] font-semibold">10 Hrs</p>
                        </div>
                    </div>
                </div> */}

                {/* <div className="flex flex-wrap justify-center 4xl:justify-between items-center gap-[30px] w-full">
                    <div className="flex justify-between w-[450px] 4xl:w-[30%] h-[105px] bg-[#FAFAFB] pl-[15px]">
                        <div className="flex gap-[10px] items-center">
                            <img
                            src={`${BaseUrl}/api/images/Instructors?url=${instructor?.Instructor?.ProfileImage}`}
                            alt="Instructor"
                            className="w-[66px] h-[66px] rounded-[9px]"
                            />
                            <p className="text-[16px] font-semibold text-[#696974] w-[130px]">
                            {instructor?.FirstName} {instructor?.LastName}
                            </p>

                            <div
                            onClick={handlePrev}
                            className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#0AA630] cursor-pointer"
                            >
                            <ArrowBackIcon sx={{ color: 'white' }} />
                            </div>
                            <div
                            onClick={handleNext}
                            className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#0AA630] cursor-pointer"
                            >
                            <ArrowForwardIcon sx={{ color: 'white' }} />
                            </div>
                        </div>

                        <div
                            className="bg-[#EBF8EE] bg-no-repeat p-[10px] flex flex-col gap-[10px] justify-center items-center"
                            style={{ border: '1px solid #0AA630' }}
                        >
                            <p className="text-[14px] text-[#696974] font-poppinssans text-center w-[80px]">
                            In-Vehicle Classes
                            </p>
                            <p className="text-[16px] text-[#696974] font-semibold">10 Hrs</p>
                        </div>
                    </div>
                </div> */}


                     {/* <div className="flex gap-8">
                                        <div className="w-[70px]">
                                            <p className="text-[15px] 2xl:text-[16px]">Monday</p>
                                        </div>
                                        <div className="flex gap-[5px]">
                                            <span className="material-symbols-outlined text-[#A1A3EF]">
                                                radio_button_checked
                                            </span>
                                        <div className="flex flex-col gap-2 text-[15px] 2xl:text-[16px]">09:00 AM - 10:00 AM</div> 
                                        </div>
                                    </div>

                                    <div className="flex gap-8">
                                        <div className="w-[70px]">
                                            <p className="text-[15px] 2xl:text-[16px]">Tuesday</p>
                                        </div>
                                        <div className="flex gap-[5px]">
                                            <span className="material-symbols-outlined text-[#A1A3EF]">
                                                radio_button_checked
                                            </span>
                                        <div className="flex flex-col gap-2 text-[15px] 2xl:text-[16px]">09:00 AM - 10:00 AM</div> 
                                        </div>
                                    </div>

                                    <div className="flex gap-8">
                                        <div className="w-[70px]">
                                            <p className="text-[15px] 2xl:text-[16px]">Wednesday</p>
                                        </div>
                                        <div className="flex gap-[5px]">
                                            <span className="material-symbols-outlined text-[#A1A3EF]">
                                                radio_button_checked
                                            </span>
                                        <div className="flex flex-col gap-2 text-[15px] 2xl:text-[16px]">09:00 AM - 10:00 AM</div> 
                                        </div>
                                    </div>

                                    <div className="flex gap-8">
                                        <div className="w-[70px]">
                                            <p className="text-[15px] 2xl:text-[16px]">Thursday</p>
                                        </div>
                                        <div className="flex gap-[5px]">
                                            <span className="material-symbols-outlined text-[#A1A3EF]">
                                                radio_button_checked
                                            </span>
                                        <div className="flex flex-col gap-2 text-[15px] 2xl:text-[16px]">09:00 AM - 10:00 AM</div> 
                                        </div>
                                    </div> */}


                            //         <div className="w-full flex flex-col gap-[10px] pb-[10px]">
                            //         <div className="w-full flex gap-[20px]">
                            //             <div className="flex items-center gap-[10px] ml-[10px]">
                            //                 <input type="checkbox" id="myCheckbox" className="w-[20px] h-[20px]" style={{border:"1px solid #FF52C5"}} />
                            //                 <label htmlFor="myCheckbox" className="text-[16px] text-[#696974]">
                            //                     Instructor 1 Classes
                            //                 </label>
                            //             </div>
                            //         </div>

                            //         <div className="w-full flex gap-[20px]">
                            //             <div className="flex items-center gap-[10px] ml-[10px]">
                            //                 <input type="checkbox" id="myCheckbox" className="w-[20px] h-[20px]" style={{border:"1px solid #FF52C5"}} />
                            //                 <label htmlFor="myCheckbox" className="text-[16px] text-[#696974]">
                            //                     Instructor 2 Classes
                            //                 </label>
                            //             </div>
                            //         </div>

                            //         <div className="w-full flex gap-[20px]">
                            //             <div className="flex items-center gap-[10px] ml-[10px]">
                            //                 <input type="checkbox" id="myCheckbox" className="w-[20px] h-[20px]" style={{border:"1px solid #FF52C5"}} />
                            //                 <label htmlFor="myCheckbox" className="text-[16px] text-[#696974]">
                            //                     Instructor 3 Classes
                            //                 </label>
                            //             </div>
                            //         </div>
                            //    </div>


                            {/* {CourseInstructors.map((instructor, index) => (
                                        <div key={instructor?.CourseInstructors?.InstructorId || index} className="w-full flex gap-[20px]">
                                        <div className="flex items-center gap-[10px] ml-[10px]">
                                            <input
                                            type="checkbox"
                                            id={`instructor-${instructor?.CourseInstructors?.InstructorId}`}
                                            className="w-[20px] h-[20px]"
                                            style={{ border: '1px solid #FF52C5' }}
                                            />
                                            <label
                                            htmlFor={`instructor-${instructor?.CourseInstructors?.InstructorId}`}
                                            className="text-[16px] text-[#696974]"
                                            >
                                            {`${instructor.FirstName} ${instructor.LastName}`}
                                            </label>
                                        </div>
                                        </div>
                                    ))} */}


                {/* {showStudentSchedule && (
                <div className="mt-4 w-full flex flex-col gap-[10px]">
                    {Object.entries(ScheduleTimeTable)?.map(([day, times]) => (
                    times.length > 0 && (
                        <div key={day} className="flex gap-8">
                        <div className="w-[70px]">
                            <p className="text-[15px] 2xl:text-[16px]">{day}</p>
                        </div>
                        <div className="flex gap-[5px]">
                            <span className="material-symbols-outlined text-[#A1A3EF]">
                            radio_button_checked
                            </span>
                            <div className="flex flex-col gap-2 text-[15px] 2xl:text-[16px]">
                            {times.map((slot, index) => (
                                <div key={index}>{slot}</div>
                            ))}
                            </div>
                        </div>
                        </div>
                    )
                    ))}
                </div>
                )} */}


                 // const showSchedule = async (value) => {
    //     const instructorId = value?.Instructor?.InstructorId;

    //     // Fetch data from the API and update state with the fetched data
    //     axios.get(`/api/teacher/schedule/${instructorId}`)
    //         .then((response) => {
    //             if (response.data && Array.isArray(response.data)) {
    //                 console.log("response.data in the show schedule is:",response.data)
    //                 // setData(response.data);
    //                 if (response.data && response.data.length > 0) {
    //                     console.log("data.length in the show schedule is:",response.data)
    //                     const data = response.data;
    //                     const transformedData = data.map((value) => {
    //                         value.endDate = new Date(value.endDate);
    //                         value.startDate = new Date(value.startDate);
    //                         return value;
    //                     });
    //                     setInstituteClasses(transformedData);
                        
    //                 }
    //             } else {
    //                 console.error('Invalid response structure:', response);
    //             }
    //         })
    //         .catch((error) => console.error(error));
    // };



     // const handleSeparateScheduleAddClass = () => {
    //     // 1. Validation
    //     if (!selectedWeeklyScheduleDate || !startTime || !endTime) {
    //       console.log("Validation failed", { selectedWeeklyScheduleDate, startTime, endTime });
    //       setError('Please select a date and both start/end time.');
    //       return;
    //     }
      
    //     console.log("Validation passed");
      
    //     setError('');

    //     // 🆕 New Check Here
    //     const classType = instructorSelectedType;
    //     const totalHoursForType = CoursePackage?.[`${classType}Hours`] || 0;

    //     const getTotalScheduledHours = (scheduleArray) => {
    //         return scheduleArray.reduce((total, cls) => {
    //           const start = new Date(cls.StartTime);
    //           const end = new Date(cls.EndTime);
    //           const durationInHours = (end - start) / (1000 * 60 * 60); // ms to hours
    //           return total + durationInHours;
    //         }, 0);
    //       };
          
    //     let existingScheduledHours = 0;
    //     if (classType === "Driving") {
    //     existingScheduledHours = getTotalScheduledHours(finalDrivingClassesSchedule);
    //     } else if (classType === "Online") {
    //     existingScheduledHours = getTotalScheduledHours(finalOnlineClassesSchedule);
    //     } else if (classType === "InClass") {
    //     existingScheduledHours = getTotalScheduledHours(finalInClassClassesSchedule);
    //     }

    //     console.log(`Total allowed hours for ${classType}:`, totalHoursForType);
    //     console.log(`Already scheduled hours:`, existingScheduledHours);

    //     if (existingScheduledHours >= totalHoursForType) {
    //     setError(`Class hours completed for ${classType} schedule.`);
    //     console.log(`❌ Cannot add more ${classType} classes. Limit reached.`);
    //     return;
    //     }

    //     const typeToIndex = {
    //       Driving: 0,
    //       Online: 1,
    //       InClass: 2,
    //     };
      
    //     const idx = typeToIndex[instructorSelectedType] ?? 0;
    //     const chosenInstructor = InstructorState[idx] || {};
      
    //     const instructorFullName = chosenInstructor.InstructorName || "";
    //     const instructorId = chosenInstructor?.InstructorFK || "";
      
    //     const typeColors = {
    //       Driving: '#0AA630',
    //       Online: '#FC0000',
    //       InClass: '#1F7BF4',
    //     };
      
    //     // 2. Date Parsing
    //     // const baseDate = getNextDateOfDay(selectedDay[0]);
    //     // const baseDate = isDateSelected ? new Date(selectedDate) : getNextDateOfDay(selectedDay[0]);
    //     const baseDate = isDateSelected 
    //     ? new Date(new Date(selectedDate).setHours(0, 0, 0, 0)) 
    //     : getNextDateOfDay(selectedDay[0]);
      
    //     console.log("Base date calculated from selectedDay:", baseDate);
      
    //     const [startHour, startMin] = startTime.split(':');
    //     const [endHour, endMin] = endTime.split(':');
      
    //     const startDate = new Date(baseDate);
    //     startDate.setHours(+startHour, +startMin, 0, 0);
      
    //     const endDate = new Date(baseDate);
    //     endDate.setHours(+endHour, +endMin, 0, 0);
      
    //     // 3. New Class Object
    //     const newClass = {
    //       allDay: false,
    //       Subject: `${instructorSelectedType} Class`,
    //       StartTime: startDate,
    //       EndTime: endDate,
    //       startDate: startDate,
    //       endDate: endDate,
    //       start: startDate.toISOString(),
    //       end: endDate.toISOString(),
    //       text: '',
    //       ClassType: instructorSelectedType,
    //       Instructors: instructorId,
    //       event_id: `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
    //       ClassNo: addClassEvents.length + 1,
    //       CategoryColor: typeColors[instructorSelectedType] || '#000000',
    //       InstructorName: instructorFullName,
    //     };
      
    //     console.log("New class generated:", newClass);
      
    //     // 4. Update events
    //     const updatedAddClassEvents = [...addClassEvents, newClass];
    //     console.log("Updated events array length:", updatedAddClassEvents.length);
      
    //     // setAddClassEvents(updatedAddClassEvents);
    //     setAddClassEvents(prev => [...prev, newClass]);

      
    //     if (instructorSelectedType === "Driving") {
    //       setFinalDrivingClassesSchedule(prev => [...prev, newClass]);
    //     } else if (instructorSelectedType === "Online") {
    //       setFinalOnlineClassesSchedule(prev => [...prev, newClass]);
    //     } else if (instructorSelectedType === "InClass") {
    //       setFinalInClassClassesSchedule(prev => [...prev, newClass]);
    //     }
      
    //     setCombinedEvents([
    //       ...studentScheduleEvents,
    //       ...instituteClasses,
    //       ...addClassEvents,
    //       ...finalClassesSchedule,
    //       newClass
    //     ]);
      
    //     console.log("Combined events updated. Modal should close.");
      
    //     // 5. Close modal
    //     setSelectedDate(null);
    //     setIsDateSelected(false);

    //     setShowAddClassPopup(false);
    //   };
      





    // const handleSeparateScheduleAddClass = () => {
    //     // 1. Validation
    //     if (!selectedWeeklyScheduleDate || !startTime || !endTime) {
    //       console.log("Validation failed", { selectedWeeklyScheduleDate, startTime, endTime });
    //       setError('Please select a date and both start/end time.');
    //       return;
    //     }
      
    //     setError('');
      
    //     const classType = instructorSelectedType;
    //     const totalHoursForType = CoursePackage?.[`${classType}Hours`] || 0;
      
    //     const getTotalScheduledHours = (scheduleArray) => {
    //       return scheduleArray.reduce((total, cls) => {
    //         const start = new Date(cls.StartTime);
    //         const end = new Date(cls.EndTime);
    //         return total + (end - start) / (1000 * 60 * 60); // in hours
    //       }, 0);
    //     };
      
    //     let existingScheduledHours = 0;
    //     if (classType === "Driving") {
    //       existingScheduledHours = getTotalScheduledHours(finalDrivingClassesSchedule);
    //     } else if (classType === "Online") {
    //       existingScheduledHours = getTotalScheduledHours(finalOnlineClassesSchedule);
    //     } else if (classType === "InClass") {
    //       existingScheduledHours = getTotalScheduledHours(finalInClassClassesSchedule);
    //     }
      
    //     if (existingScheduledHours >= totalHoursForType) {
    //       setError(`Class hours completed for ${classType} schedule.`);
    //       return;
    //     }
      
    //     const typeToIndex = {
    //       Driving: 0,
    //       Online: 1,
    //       InClass: 2,
    //     };
      
    //     const idx = typeToIndex[instructorSelectedType] ?? 0;
    //     const chosenInstructor = InstructorState[idx] || {};
    //     const instructorFullName = chosenInstructor.InstructorName || "";
    //     const instructorId = chosenInstructor?.InstructorFK || "";
      
    //     const typeColors = {
    //       Driving: '#0AA630',
    //       Online: '#FC0000',
    //       InClass: '#1F7BF4',
    //     };
      
    //     // 📅 Use selectedDate directly
    //     const baseDate = new Date(new Date(selectedWeeklyScheduleDate).setHours(0, 0, 0, 0));
    //     const [startHour, startMin] = startTime.split(':');
    //     const [endHour, endMin] = endTime.split(':');
      
    //     const startDate = new Date(baseDate);
    //     startDate.setHours(+startHour, +startMin, 0, 0);
      
    //     const endDate = new Date(baseDate);
    //     endDate.setHours(+endHour, +endMin, 0, 0);
      
    //     const newClass = {
    //       allDay: false,
    //       Subject: `${instructorSelectedType} Class`,
    //       StartTime: startDate,
    //       EndTime: endDate,
    //       startDate: startDate,
    //       endDate: endDate,
    //       start: startDate.toISOString(),
    //       end: endDate.toISOString(),
    //       text: '',
    //       ClassType: instructorSelectedType,
    //       Instructors: instructorId,
    //       event_id: `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
    //       ClassNo: addClassEvents.length + 1,
    //       CategoryColor: typeColors[instructorSelectedType] || '#000000',
    //       InstructorName: instructorFullName,
    //     };
      
    //     // setAddClassEvents(prev => [...prev, newClass]);
    //     const updatedAddClassEvents = [...addClassEvents, newClass];
    //     console.log("Updated events array length:", updatedAddClassEvents.length);
      
    //     setAddClassEvents(updatedAddClassEvents);
      
    //     if (instructorSelectedType === "Driving") {
    //       setFinalDrivingClassesSchedule(prev => [...prev, newClass]);
    //     } else if (instructorSelectedType === "Online") {
    //       setFinalOnlineClassesSchedule(prev => [...prev, newClass]);
    //     } else if (instructorSelectedType === "InClass") {
    //       setFinalInClassClassesSchedule(prev => [...prev, newClass]);
    //     }
      
    //     setCombinedEvents([
    //       ...studentScheduleEvents,
    //       ...instituteClasses,
    //       ...updatedAddClassEvents,
    //       ...finalClassesSchedule,
    //     ]);
      
    //     setSelectedWeeklyScheduleDate(null);
    //     setShowWeeklyAddClassPopup(false);
    //   };



    // const generateRecurringClasses = ({
    //     dayTimeCombos,
    //     instructorType,
    //     instructorId,
    //     instructorName,
    //     totalHours,
    //     startDate = new Date(),
    //     existingClassesLength = 0
    //   }) => {
        
    //     const typeColors = {
    //       Driving: '#0AA630',
    //       Online: '#FC0000',
    //       InClass: '#1F7BF4',
    //     };
      
    //     const dayNameToIndex = {
    //       Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3,
    //       Thursday: 4, Friday: 5, Saturday: 6,
    //     };
      
    //     const groupedCombos = {};
    //     for (const combo of dayTimeCombos) {
    //       const dayIndex = dayNameToIndex[combo.day];
    //       if (!groupedCombos[dayIndex]) groupedCombos[dayIndex] = [];
    //       groupedCombos[dayIndex].push({ ...combo, dayIndex });
    //     }
      
    //     const sortedDayIndexes = Object.keys(groupedCombos).map(Number).sort((a, b) => a - b);
      
    //     const events = [];
    //     let hoursScheduled = 0;
    //     let weekOffset = 0;
      
    //     while (hoursScheduled < totalHours) {
    //       for (const dayIndex of sortedDayIndexes) {
    //         const combosForDay = groupedCombos[dayIndex];
    //         for (const combo of combosForDay) {
    //           if (hoursScheduled >= totalHours) break;
      
    //         //   const weekStart = new Date(startDate);
    //         //   weekStart.setDate(weekStart.getDate() + weekOffset * 7);
    //         //   weekStart.setHours(0, 0, 0, 0);
      
    //         //   const dayDiff = (dayIndex - weekStart.getDay() + 7) % 7;
    //         //   const classDate = new Date(weekStart);
    //         //   classDate.setDate(classDate.getDate() + dayDiff);

    //             const weekStart = new Date(startDate);
    //             weekStart.setDate(weekStart.getDate() - weekStart.getDay() + weekOffset * 7);
    //             weekStart.setHours(0, 0, 0, 0);

    //             const dayDiff = (dayIndex - weekStart.getDay() + 7) % 7;
    //             const classDate = new Date(weekStart);
    //             classDate.setDate(classDate.getDate() + dayDiff);
      
    //           const fullStart = new Date(`${classDate.toDateString()} ${combo.startTime}`);
    //           const fullEnd = new Date(`${classDate.toDateString()} ${combo.endTime}`);
      
    //           const slotDuration = (fullEnd - fullStart) / (1000 * 60 * 60);
    //           const remainingHours = totalHours - hoursScheduled;
    //           const classDuration = Math.min(slotDuration, remainingHours);
      
    //           const classEnd = new Date(fullStart.getTime() + classDuration * 60 * 60 * 1000);
      
    //           const event = {
    //             allDay: false,
    //             Subject: `${combo.day} Class`,
    //             StartTime: fullStart,
    //             EndTime: classEnd,
    //             startDate: fullStart,
    //             endDate: classEnd,
    //             start: fullStart.toISOString(),
    //             end: classEnd.toISOString(),
    //             text: '',
    //             ClassType: instructorType,
    //             Instructors: instructorId,
    //             event_id: `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
    //             ClassNo: existingClassesLength + events.length + 1,
    //             CategoryColor: typeColors[instructorType] || '#000000',
    //             InstructorName: instructorName,
    //           };
      
    //           events.push(event);
    //           hoursScheduled += classDuration;
      
    //           if (hoursScheduled >= totalHours) break;
    //         }
    //       }
      
    //       weekOffset++;
    //     }
      
    //     return events;
    //   };



     // const handleAddClass = (skipValidation = false) => {
    // // if (!selectedDay.length || !startTime || !endTime) {
    // //     console.log('selectedDay is:',selectedDay);
    // //     setError('Please select at least one day and both start/end time.');
    // //     return;
    // // }

    // if (!skipValidation && (!selectedDay.length || !startTime || !endTime)) {
    //     console.log('selectedDay is:', selectedDay);
    //     setError('Please select at least one day and both start/end time.');
    //     return;
    //   }
    
    // const totalHoursByType = {
    //     Driving: DrivingHours,
    //     Online: OnlineHours,
    //     InClass: InClassHours,
    // };
    
    // const totalHours = totalHoursByType[instructorSelectedType] || 0;
    
    // const remainingEvents = addClassEvents.filter(
    //     event => event.ClassType !== instructorSelectedType
    // );
    
    // const previousCombos = addClassEvents
    //     .filter(event => event.ClassType === instructorSelectedType)
    //     .map(event => {
    //     const day = new Date(event.startDate).toLocaleDateString('en-US', { weekday: 'long' });
    //     const startTime = new Date(event.startDate).toTimeString().slice(0, 5);
    //     const endTime = new Date(event.endDate).toTimeString().slice(0, 5);
    //     return { day, startTime, endTime };
    //     });
    
    // const newCombos = selectedDay.map(day => ({ day, startTime, endTime }));
    
    // const comboKey = combo => `${combo.day}-${combo.startTime}-${combo.endTime}`;
    // const combinedCombosMap = new Map();
    
    // [...previousCombos, ...newCombos].forEach(combo => {
    //     combinedCombosMap.set(comboKey(combo), combo);
    // });
    
    // const mergedCombos = Array.from(combinedCombosMap.values());

    // const typeToIndex = {
    //     Driving: 0,
    //     Online: 1,
    //     InClass: 2,
    //     };
        
    // const idx = typeToIndex[instructorSelectedType] ?? 0;
    // const chosenInstructor = InstructorState[idx] || {};

    // const instructorFullName = chosenInstructor.InstructorName || "";
    // const instructorId = chosenInstructor?.InstructorFK || "";
    
    // const startDate = selectedDate ? selectedDate.toDate() : new Date();

    // const newClasses = generateRecurringClasses({
    //     dayTimeCombos: mergedCombos,
    //     instructorType: instructorSelectedType,
    //     instructorId,
    //     instructorName: instructorFullName,
    //     totalHours,
    //     existingClassesLength: remainingEvents.length,
    //     startDate,
    // });
    
    // const updatedAddClassEvents = [...remainingEvents, ...newClasses];
    // setAddClassEvents(updatedAddClassEvents);
    // setCombinedEvents([
    //     ...studentScheduleEvents,
    //     ...instituteClasses,
    //     ...updatedAddClassEvents,
    //     ... finalClassesSchedule,
    // ]);
    
    // setSelectedDay([])
    // setError("")
    // setShowAddClassPopup(false);
    // };
